<!-- Copyright 2023, Common Good Learning Tools LLC -->
<template>
	<k-dialog v-model="dialog_open" :content-class="dialog_class" :fullscreen="lti_chooser" :transition="lti_chooser?'':'dialog-transition'" overlay-opacity="0.9" persistent scrollable :restore-focus-element="restoreFocusElement" @escape="done_clicked">
		<k-card>
			<k-card-title v-if="!lti_chooser" class="indigo darken-3 white--text" style="border-bottom:1px solid #999; padding:8px 8px 8px 16px;">
				<b v-html="cdialog_title"></b>
				<k-spacer/>
				<!-- hidden button to show search scores -->
				<k-btn x-small :style="($store.state.show_search_match_scores)?'opacity:0.3':'opacity:0.0'" @click="$store.state.show_search_match_scores=!$store.state.show_search_match_scores">sms {{ $store.state.show_search_match_scores }}</k-btn>
				<k-spacer/>
				<div v-if="!search_only&&show_move_btn" class="mr-4" v-show="searchable_items.length"><k-btn class="k-tight-btn" small :text="!at_least_one_item_selected" :color="at_least_one_item_selected?'#fff':'#999'" @click="add_selected_items('move')"><k-icon small v-show="at_least_one_item_selected" class="mr-2">fas fa-suitcase-rolling</k-icon>Move selected item{{max_items!=1?'s':''}}</k-btn></div>
				<div v-if="!search_only&&new_or_search=='search'" class="mr-4" v-show="searchable_items.length"><k-btn class="k-tight-btn" :text="!at_least_one_item_selected" :color="at_least_one_item_selected?'#fff':'#999'" @click="add_selected_items"><k-icon v-show="at_least_one_item_selected" small class="mr-2">fas fa-check</k-icon>Add selected item{{max_items!=1?'s':''}}</k-btn></div>
				<k-btn color="#fff" text @click="done_clicked">Done<k-icon class="ml-2">fas fa-xmark</k-icon></k-btn>
			</k-card-title>
			<k-card-text class="k-search-card pt-3">
				<!-- Search/Create toggle -->
				<div v-if="!search_only" class="my-1 d-flex"><k-spacer/>
					<k-btn-toggle dense active-class="k-toggle-btn-active-class indigo darken-4" class="k-toggle-btn" v-model="new_or_search" mandatory>
						<k-btn style="width:240px" light class="k-nocaps-btn k-tight-btn" value="search" @click.stop=""><k-icon small :color="new_or_search=='search'?'white':'black'" class="mr-2">fas fa-search</k-icon>Search EXISTING</k-btn>
						<k-btn light class="k-nocaps-btn k-tight-btn" value="shared" @click.stop=""><k-icon small :color="new_or_search=='shared'?'white':'black'" class="mr-2">fas fa-share</k-icon>Import SHARED</k-btn>
						<k-btn light class="k-nocaps-btn k-tight-btn" value="new" @click.stop=""><k-icon small :color="new_or_search=='new'?'white':'black'" class="mr-2">fas fa-plus</k-icon>Create NEW</k-btn>
					</k-btn-toggle>
				<k-spacer/></div>

				<!-- Create interface -->
				<div v-show="new_or_search=='new'">
					<div v-if="citem_types.length>1" class="mt-6 mb-4 d-flex align-center"><k-spacer/>
						<b style="font-size:20px">Create New:</b>
						<k-btn v-if="citem_types.includes('lessons')" class="ml-3" dark color="blue darken-3" @click="create_lesson_start"><span class="pl-3 pr-5"><k-icon small class="mr-2">fas fa-rectangle-list</k-icon>Lesson Plan</span></k-btn>
						<k-btn v-if="citem_types.includes('activities')" class="ml-3" dark color="deep-purple darken-3" @click="create_activity_start"><k-icon small class="mr-2">fas fa-star</k-icon>{{site_config.sparkl_app_name}} Student Activity</k-btn>
						<k-btn v-if="citem_types.includes('resources')" class="ml-3" dark color="teal darken-3" @click="create_new_resource"><k-icon small class="mr-2">fas fa-link</k-icon>Other Resource</k-btn>
					<k-spacer/></div>
					<div v-if="citem_types.length==1" class="mt-6 mb-4 d-flex align-center"><k-spacer/>
						<k-btn v-if="citem_types[0]=='lessons'" dark color="blue darken-3" @click="create_lesson_start"><span class="pl-3 pr-5"><k-icon small class="mr-2">fas fa-rectangle-list</k-icon>Create New Lesson Plan</span></k-btn>
						<k-btn v-if="citem_types[0]=='activities'" dark color="deep-purple darken-3" @click="create_activity_start"><k-icon small class="mr-2">fas fa-star</k-icon>Create New {{site_config.sparkl_app_name}} Student Activity</k-btn>
						<k-btn v-if="citem_types[0]=='resources'" dark color="teal darken-3" @click="create_new_resource"><k-icon small class="mr-2">fas fa-link</k-icon>Create New Resource</k-btn>
					<k-spacer/></div>
					<k-hover v-slot:default="{hover}" v-if="show_alba_btn"><div style="position:absolute; right:204px; bottom:4px; background-color:#ccc; font-size:14px; line-height:14px; padding:4px; border-radius:6px; cursor:pointer" :style="'opacity:'+(hover?'0.5':'0')" @click="alba_showing=true">ALBA</div></k-hover>
					<k-hover v-slot:default="{hover}" v-if="show_gavs_btn"><div style="position:absolute; right:104px; bottom:4px; background-color:#ccc; font-size:14px; line-height:14px; padding:4px; border-radius:6px; cursor:pointer" :style="'opacity:'+(hover?'0.5':'0')" @click="bulk_activity_editor_showing=true">GAVS IMPORT</div></k-hover>
					<k-hover v-slot:default="{hover}" v-if="show_import_btn"><div style="position:absolute; right:4px; bottom:4px; background-color:#ccc; font-size:14px; line-height:14px; padding:4px; border-radius:6px; cursor:pointer" :style="'opacity:'+(hover?'0.5':'0')" @click="bulk_importer_showing=true">BULK IMPORT</div></k-hover>
				</div>

				<!-- Import interface -->
				<div v-show="new_or_search=='shared'">
					<div v-if="citem_types.length>1" class="mt-6 mb-4 d-flex align-center"><k-spacer/>
						<b style="font-size:20px">Import Shared:</b>
						<k-btn v-if="citem_types.includes('lessons')" class="ml-3" dark color="blue darken-3" @click="import_shared_item('lesson')"><span class="pl-3 pr-5"><k-icon small class="mr-2">fas fa-rectangle-list</k-icon>Lesson Plan</span></k-btn>
						<k-btn v-if="citem_types.includes('activities')" class="ml-3" dark color="deep-purple darken-3" @click="import_shared_item('activity')"><k-icon small class="mr-2">fas fa-star</k-icon>{{site_config.sparkl_app_name}} Student Activity</k-btn>
						<k-btn v-if="citem_types.includes('resources')" class="ml-3" dark color="teal darken-3" @click="import_shared_item('resource')"><k-icon small class="mr-2">fas fa-link</k-icon>Other Resource</k-btn>
					<k-spacer/></div>
					<div v-if="citem_types.length==1" class="mt-6 mb-4 d-flex align-center"><k-spacer/>
						<k-btn v-if="citem_types[0]=='lessons'" dark color="blue darken-3" @click="import_shared_item('lesson')"><span class="pl-3 pr-5"><k-icon small class="mr-2">fas fa-rectangle-list</k-icon>Import Shared Lesson</span></k-btn>
						<k-btn v-if="citem_types[0]=='activities'" dark color="deep-purple darken-3" @click="import_shared_item('activity')"><k-icon small class="mr-2">fas fa-star</k-icon>Import Shared {{site_config.sparkl_app_name}} Student Activity</k-btn>
						<k-btn v-if="citem_types[0]=='resources'" dark color="teal darken-3" @click="import_shared_item('resource')"><k-icon small class="mr-2">fas fa-link</k-icon>Import Shared Resource</k-btn>
					<k-spacer/></div>
					<div>
						<div v-for="(sr, i) in imported_items" :key="sr.item_id">
							<div v-if="i==0" class="k-full-resource-search-result-category">
								<b>Imported Items ({{imported_items.length}})</b>
							</div>
							<div class="k-resource-folder-resource-item-full-wrapper k-resource-folder-resource-item-hovered k-full-resource-search-result-already-added" style="display:flex;">
								<div v-if="!search_only"><k-checkbox class="shrink mt-0 pt-0 d-inline-block" :disabled="true" hide-details v-model="sr.selected"></k-checkbox></div>
								<div style="flex:1 0 100px"><ResourceCollectionItem :key="sr.item_id" :full_width_resource="true"
									:item="sr.value"
									:option_overrides="rci_option_overrides(sr)"
									@unpublish_item_start="unpublish_item_start"
									@edit_item_start="edit_item_start" 
									@edit_item_saved="edit_item_saved"
									@copy_to_shadow_unit_finish="copy_to_shadow_unit_finish"
								/></div>
							</div>
						</div>
					</div>
					<div v-if="site_config.import_warning" class="mt-3 pt-3 px-5" style="border-top:1px solid #ccc; font-size:14px; line-height:18px;" v-html="site_config.import_warning"></div>
				</div>

				<!-- Search interface -->
				<div v-show="new_or_search=='search'">
					<div class="mb-2 d-flex flex-wrap justify-center align-center">

						<!-- menu for choosing the universe of what you're searching in -- i.e. all items in the site, or a collection -->
						<div v-if="true||search_crit!='standards'" class="xd-flex mx-2 my-2 k-search-options-holder">
							<!-- <div class="mr-3" style="margin-top:6px"><b>Search In:</b></div> -->
							<div class="k-search-options-holder-label">Search In:</div>

							<k-menu offset-y bottom v-model="limit_menu_showing" accessible-popover accessible-label="Search scope options" content-id="resource-search-scope-menu">
								<template v-slot:activator="{on, attrs}"><k-btn v-on="on" v-bind="attrs" class="k-nocaps-btn" color="indigo darken-3" dark accessible-label="Choose search scope">
									<!-- <k-icon small class="mr-1">fas fa-filter</k-icon>Select… -->
									<div v-if="selected_home_lesson" class="k-search-options-search-in-descriptor">
										<b>Resources tagged to this lesson</b>
									</div>
									<div v-if="selected_home_collection" class="k-search-options-search-in-descriptor">
										<k-icon small class="mr-1">{{home_collection.collection_icon()}}</k-icon>
										{{home_collection.title}}
									</div>
									<div v-if="selected_my" class="k-search-options-search-in-descriptor">
										<k-icon small class="mr-1">fa-umbrella-beach</k-icon>
										{{site_config.default_my_collection_label}}
									</div>
									<div v-if="selected_collection" class="k-search-options-search-in-descriptor">
										<k-icon small class="mr-1">{{selected_collection.collection_icon()}}</k-icon>
										{{selected_collection.title}}
									</div>
									<div v-if="search_all" class="k-search-options-search-in-descriptor">
										<k-icon small class="mr-1">fas fa-globe</k-icon>
										All items in {{site_config.app_name}}
									</div>
									<k-icon color="#fff" class="ml-2">fas fa-caret-down</k-icon>
								</k-btn></template>
								<k-list min-width="450" dense>
									<k-list-item v-if="home_lesson&&allow_add_from_home" @click.stop="search_source_clicked('home_lesson')"><k-list-item-icon style="margin-top:8px;margin-bottom:12px;"><span :class="selected_home_lesson?'indigo darken-3':''" style="width:30px;height:30px;border-radius:30px;text-align:center;line-height:30px;"><k-icon style="margin-top:-3px;width:30px;height:30px;" :color="selected_home_lesson?'#fff':''" small>fas fa-rectangle-list</k-icon></span></k-list-item-icon><k-list-item-title :style="selected_home_lesson?'font-weight:bold':''" :class="selected_home_lesson?'indigo--text text--darken-3':''">Resources tagged to this lesson</k-list-item-title></k-list-item>
									<k-list-item @click.stop="search_source_clicked('site')"><k-list-item-icon style="margin-top:8px;margin-bottom:12px;"><span :class="search_all?'indigo darken-3':''" style="width:30px;height:30px;border-radius:30px;text-align:center;line-height:30px;"><k-icon style="margin-top:-3px;width:30px;height:30px;" :color="search_all?'#fff':''" small>fas fa-globe</k-icon></span></k-list-item-icon><k-list-item-title :style="search_all?'font-weight:bold':''" :class="search_all?'indigo--text text--darken-3':''">All items in {{site_config.app_name}}</k-list-item-title></k-list-item>
									<!-- can't add from my_default_collection TO my_default_collection; also if the user isn't signed in, no sandbox -->
									<k-list-item v-if="signed_in&&home_collection!=my_default_collection" @click.stop="search_source_clicked('my')"><k-list-item-icon style="margin-top:8px;margin-bottom:12px;"><span :class="selected_my?'indigo darken-3':''" style="width:30px;height:30px;border-radius:30px;text-align:center;line-height:30px;"><k-icon style="margin-top:-3px;width:30px;height:30px;" :color="selected_my?'#fff':''" small>fas fa-umbrella-beach</k-icon></span></k-list-item-icon><k-list-item-title :style="selected_my?'font-weight:bold':''" :class="selected_my?'indigo--text text--darken-3':''">{{site_config.default_my_collection_label}}</k-list-item-title></k-list-item>
									<k-list-item v-if="home_collection&&allow_add_from_home" @click.stop="search_source_clicked('home_collection')"><k-list-item-icon style="margin-top:8px;margin-bottom:12px;"><span :class="selected_home_collection?'indigo darken-3':''" style="width:30px;height:30px;border-radius:30px;text-align:center;line-height:30px;"><k-icon style="margin-top:-3px;width:30px;height:30px;" :color="selected_home_collection?'#fff':''" small>{{home_collection.collection_icon()}}</k-icon></span></k-list-item-icon><k-list-item-title :style="selected_home_collection?'font-weight:bold':''" :class="selected_home_collection?'indigo--text text--darken-3':''">This content collection (“{{home_collection.title}}”)</k-list-item-title></k-list-item>
									<k-list-item @click.stop=""><k-list-item-icon v-if="selected_collection" style="margin-top:12px"><span :class="selected_collection?'indigo darken-3':''" style="width:30px;height:30px;border-radius:30px;text-align:center;line-height:30px;"><k-icon style="margin-top:-3px;width:30px;height:30px;" :color="selected_collection?'#fff':''" small>{{selected_collection.collection_icon()}}</k-icon></span></k-list-item-icon><k-list-item-title><div class="mt-2">
										<k-autocomplete clearable v-model="selected_collection" :items="course_selection_array" label="Choose a Course, Repository, or Collection" outlined hide-details dense background-color="#fff">
											<template v-slot:item="data"><div style="font-size:14px;">
												<k-icon small class="mr-1" color="#000" style="font-size:14px; margin-top:-2px">{{ data.item.value.collection_icon() }}</k-icon>
												{{ data.item.value.title }}
											</div></template>
										</k-autocomplete>
									</div></k-list-item-title></k-list-item>
								</k-list>
							</k-menu>
						</div>

						<!-- unit chooser -->
						<div v-if="unit_selection_array" class="xd-flex mx-2 my-2 align-center k-search-options-holder">
							<div class="k-search-options-holder-label">Unit:</div>
							<div style="width:230px">
								<k-select v-model="selected_unit" :items="unit_selection_array" outlined label="" hide-details dense>
									<template v-slot:item="data"><div style="font-size:14px;" :style="data.item.value==null?'font-weight:bold; width:100%;text-align:center':''">
										<k-icon v-if="data.item.value!=null" small class="mr-1" color="#000" style="font-size:14px; margin-top:-2px">fas fa-circle-arrow-right</k-icon>
										{{ data.item.text }}
									</div></template>
								</k-select>
							</div>
						</div>

						<!-- radio toggle between searching by terms or standards -->
						<div v-if="true" class="xd-flex mx-2 my-2 pr-0 k-search-options-holder">
							<!-- <div class="mr-3"><b>Search By:</b></div> -->
							<div class="k-search-options-holder-label" style="padding-bottom:4px;">Search By:</div>
							<k-radio-group v-model="search_crit" class="mt-0 pt-0 d-inline-block" hide-details row>
								<k-radio label="Keywords/Terms" color="indigo darken-3" :value="'keywords'" off-icon="far fa-circle" on-icon="far fa-circle-dot"></k-radio>
								<k-radio label="Standards" color="indigo darken-3" :value="'standards'" off-icon="far fa-circle" on-icon="far fa-circle-dot"></k-radio>
							</k-radio-group>
						</div>

						<!-- subject chooser for standard search; don't show in certain conditions -->
						<div v-if="subject_chooser_available" class="mx-2 my-2 align-center k-search-options-holder">
							<div class="k-search-options-holder-label">Choose a Subject:</div>
							<div style="width:230px"><k-select v-model="subject" :items="subjects" outlined label="" hide-details dense :menu-props="{maxHeight:700}">
								<template v-slot:item="data"><div style="font-size:14px;" :style="data.item.value=='all'?'font-weight:bold; border-top:1px solid #000; width:100%;text-align:center; padding-top:8px;':''">
									<k-icon v-if="data.item.value!='all'" small class="mr-1" color="#000" style="font-size:14px; margin-top:-2px">fas fa-map</k-icon>
									{{ data.item.text }}
								</div></template>
							</k-select></div>
						</div>

					</div>

					<!-- current search terms, if we're searching by keywords and we've done the "initial search" -->
					<div v-if="keyword_search && current_server_search_terms" class="d-flex mb-4">
						<k-spacer/>
						<div class="k-search-options-holder" style="height:auto;">
							<nobr>Search terms:</nobr>
							<b class="indigo--text text--darken-4 ml-1" style="font-size:18px;">{{ current_server_search_terms }}</b>
							<k-btn small class="ml-4 k-tight-btn" color="primary" @click="reset_search_all">New Search <k-icon small class="ml-2">fas fa-rotate-left</k-icon></k-btn>
						</div>
						<k-spacer/>
					</div>

					<!-- current standard that we're showing results for, if we're searching by standards and a standard has been chosen -->
					<div v-if="search_crit=='standards' && chosen_cfitem" class="d-flex mb-4">
						<k-spacer/>
						<div class="k-search-options-holder d-flex" style="height:auto;">
							<!-- <nobr class="mr-2">Current standard:</nobr> -->
							<div v-html="rendered_cfitem(chosen_cfitem)" style="white-space:normal; line-height:21px; margin-top:-6px; margin-bottom:-6px;"></div>
							<k-btn v-if="!chosen_framework_override" small class="ml-2 k-tight-btn" color="primary" @click="reset_search_all">Change Standard <k-icon small class="ml-2">fas fa-rotate-left</k-icon></k-btn>
						</div>
						<k-spacer/>
					</div>

					<!-- search box -->
					<div v-if="!search_all || (search_all && subject)" class="mb-4 d-flex align-center">
						<k-spacer/>
						<div style="flex:0 0 auto; width:600px; max-width:calc(100vw - 240px)">
							<k-text-field light rounded outlined solo hide-details clearable color="indigo darken-3"
								:placeholder="search_box_placeholder"
								v-model="search_terms"
								:prepend-inner-icon="(search_all && (!current_server_search_terms && !chosen_cfitem)) ? 'fas fa-search' : 'fas fa-filter'" 
								prepend-decorative
								aria-label="Search resources"
								@click:clear="execute_search_clear"
								@keyup="search_field_keyup"
							></k-text-field>
						</div>
						<k-btn v-if="search_all && keyword_search && !current_server_search_terms" color="primary" class="ml-3" @click="initiate_search_from_keyboard_or_search_icon"><k-icon class="mr-2">fas fa-search</k-icon>Search</k-btn>
						<k-btn v-if="standard_search && !satchel_showing && !chosen_cfitem" color="primary" class="ml-3 k-tight-btn" @click="browse_standards"><k-icon class="mr-2">fas fa-map</k-icon>Browse Standards</k-btn>

						<k-spacer/>
					</div>

					<!-- help text for when there is no subject selected and you're searching all -->
					<div v-if="subject==''&&search_all" class="mt-5 text-center indigo--text text--darken-3"><b>Please choose a subject to search<span v-if="keyword_search"> (or choose "ALL SUBJECTS")</span>.</b></div>

					<!-- help text if there are no results -->
					<div v-if="no_results_help" class="my-2 k-resource-search-results-no-results" v-html="no_results_help"></div>

					<!-- outer div for search results -->
					<div style="max-width:1000px; margin:0 auto;">
						<div v-if="searchable_items.length>0 || show_secondary_alignments_checkbox" class="d-flex align-center mb-2">

							<!-- toggle buttons for lessons/activities/resources -->
							<k-btn-toggle v-if="citem_types.length>1" dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" v-model="item_type_showing" mandatory>
								<k-btn v-if="searchable_category_count['1lesson']" class="k-tight-btn" style="width:168px; min-width:168px;" small light :value="'1lesson'" @click.stop="">
									Lesson Plans 
									<span v-if="!search_all||search_crit=='standards'" class="ml-1">({{searchable_category_count['1lesson']}})</span>
								</k-btn>
								<k-btn v-if="searchable_category_count['2sparkl']" class="k-tight-btn" style="width:168px; min-width:168px;" small light :value="'2sparkl'" @click.stop="">
									Student Activities 
									<span v-if="!search_all||search_crit=='standards'" class="ml-1">({{searchable_category_count['2sparkl']}})</span>
								</k-btn>
								<k-btn v-if="searchable_category_count['3resource']" class="k-tight-btn" style="width:182px; min-width:182px;" small light :value="'3resource'" @click.stop="">
									<span class="mr-1" v-if="searchable_category_count['1lesson'] || searchable_category_count['2sparkl']">Other</span> Resources 
									<span v-if="!search_all||search_crit=='standards'" class="ml-1">({{resource_count_string}})</span>
								</k-btn>
							</k-btn-toggle>

							<!-- menu for resource sources, if we're showing resources -->
							<div v-if="item_type_showing=='3resource' && resources_by_source" class="ml-0">
								<k-menu bottom left accessible-popover accessible-label="Resource source filters" content-id="resource-search-source-filters-menu">
									<template v-slot:activator="{on, attrs}">
										<k-btn v-on="on" v-bind="attrs" small text color="indigo darken-4" class="k-tight-btn" accessible-label="Filter resources by source">Filter by source ({{resources_selected_source_count}}/{{ resources_source_count }})</k-btn>
									</template>
									<div class="k-resources-by-source-filter elevation-3">
										<div class="d-flex align-center mb-2">
											<k-btn small icon style="margin-left:-2px;"
												:color="toggle_all_sources_icon=='fas fa-check-square'?'primary':'#666'" 
												@click.stop="toggle_select_all_sources"
												><k-icon style="font-size:18px;">{{ toggle_all_sources_icon }}</k-icon>
											</k-btn>
											<div style="flex:1 0 auto; font-size:16px; margin-left:6px;"><b>Resource Sources:</b></div>
										</div>
										<div v-for="(arr, key) in resources_by_source" style="margin-top:2px; margin-bottom:2px;">
											<k-checkbox class="mt-0 pt-0 d-inline-block" style="vertical-align:bottom" hide-details off-icon="far fa-square" on-icon="fas fa-check-square"
												v-model="resources_source_filters[key]"
												@change="generate_searchable_items"
												@click.stop=""
											>
												<template v-slot:label>{{key}} ({{arr.length}})</template>
											</k-checkbox>
										</div>
									</div>
								</k-menu>
							</div>

							<k-spacer/>

							<div v-show="show_secondary_alignments_checkbox">
								<k-checkbox class="mt-0 pt-0 d-inline-block" hide-details off-icon="far fa-square" on-icon="fas fa-check-square"
									v-model="show_secondary_alignments"
									@click.stop="generate_searchable_items"
								>
									<template v-slot:label><div style="font-size:14px">Include secondary alignments</div></template>
								</k-checkbox>
							</div>

							<div v-if="sandbox_being_shown" class="d-flex ml-2" style="flex:0 0 100px">
								<nobr style="font-size:14px" class="mr-2">Sort by:</nobr>
								<div>
									<k-btn-toggle dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" v-model="resource_search_sort_by" mandatory>
										<k-btn x-small width="80px" class="k-tight-btn" light :value="'title'" @click.stop="resource_search_sort_by = 'title'">Title</k-btn>
										<k-btn x-small width="80px" class="k-tight-btn" light :value="'created_at'" @click.stop="set_resource_search_sort_order">Date Created</k-btn>
									</k-btn-toggle>
								</div>
							</div>
						</div>
						
						<div v-if="search_crit=='standards' && !chosen_cfitem" class="k-standards-search-results-wrapper">
							<div v-for="(cfitem, i) in standard_search_results" :key="cfitem.identifier" v-if="i < 25" class="k-standards-search-result d-flex px-2 pb-1 pt-2">
								<k-btn small icon color="primary" class="mr-2" style="margin-top:-4px;" @click="browse_standards(cfitem)"><k-icon small>fas fa-map</k-icon></k-btn>
								<k-btn x-small color="primary" class="mr-2 k-tight-btn" @click="choose_cfitem_for_search(cfitem)">Choose</k-btn>
								<div v-html="rendered_cfitem(cfitem)" style="line-height:21px; margin-top:-6px; margin-bottom:-6px;"></div>
							</div>
							<div v-if="standard_search_results.length>25" class="mt-2 text-center"><i><b>Showing first 25 of {{standard_search_results.length}} items; enter additional terms to improve search</b></i></div>
						</div>

						<div v-if="lti_chooser && sandbox_being_shown && searchable_items.length==0" class="text-center mt-6" style="font-size:18px;line-height:28px;">
							<div><b>You haven’t created any {{site_config.sparkl_app_name}} activities yet.</b></div>
							<div class="mt-4">Click the <k-icon small color="black" class="mr-1">fas fa-arrow-left</k-icon>BACK button above to choose a pre-made activity to use,<br>
							or click <k-icon small color="black" class="mr-1">fas fa-arrow-left</k-icon>BACK twice and choose the option to create a new activity from scratch.</div>
						</div>

						<div v-for="(sr, i) in visible_search_results" :key="sr.item_id" class="k-resource-folder-resource-container-width-full">
							<div class="k-resource-folder-resource-item-full-wrapper k-resource-folder-resource-item-hovered" style="display:flex;" :style="asset_style(sr, i)" :class="asset_css(sr)">
								<div v-if="!search_only" style="flex:0 1 auto"><k-checkbox class="shrink mt-0 pt-0 d-inline-block" :disabled="sr.already_added" hide-details v-model="sr.selected" @change="item_checked(sr)"></k-checkbox></div>
								<!-- show search match scores: vapp.$store.state.show_search_match_scores = true -->
								<div v-if="$store.state.show_search_match_scores" style="font-size:12px; margin-top:3px;">{{ match_scores[sr.item_id] }}</div>
								<div style="flex:1 0 100px;">
									<ResourceCollectionItem
										:key="sr.item_id"
										:full_width_resource="true"
										:item="sr.value"
										:title_override="sr.title_override"
										:option_overrides="rci_option_overrides(sr)"
										@unpublish_item_start="unpublish_item_start"
										@edit_item_start="edit_item_start" 
										@edit_item_saved="edit_item_saved"
										@copy_to_shadow_unit_finish="copy_to_shadow_unit_finish"
									/>
								</div>
							</div>
						</div>

						<div v-if="visible_search_results.length > 0 && visible_search_results.length < potential_visible_search_results" class="text-center mt-3 mb-1">
							<k-btn small color="indigo darken-3" dark @click="show_more_results(item_type_showing)"><k-icon small class="mr-2">fas fa-plus</k-icon> Show More</k-btn>
						</div>
						<div v-if="search_all && visible_search_results.length > 0 && visible_search_results.length >= searchable_category_count[item_type_showing]" class="text-center mt-3 mb-1">
							<i>End of search results. Refine your search terms to find additional resources.</i>
						</div>
					</div>
				</div>
			</k-card-text>
		</k-card>

		<ResourceEditor
			v-if="new_resource_placeholder"
			:original_resource="new_resource_placeholder"
			:course="this.home_collection"
			@edit_resource_cancel="create_resource_cancel"
			@edit_resource_saved="create_resource_saved"
		/>

		<k-dialog v-if="new_lesson" v-model="new_lesson" :max-width="use_enhanced_lesson_editor?1200:900" persistent scrollable :retain-focus="false" content-class="k-resource-collection-item-lesson-card-dialog k-lpe-editor-dialog">
			<k-card class="k-resource-collection-item-lesson-card">
				<div class="d-flex">
					<k-icon class="mr-2">fas fa-rectangle-list</k-icon>
					<div class="k-lesson-title" style="font-weight:bold">New Lesson Plan</div>
					<k-spacer/>
					
					<div v-if="!show_lesson_variant_switcher&&use_enhanced_lesson_editor" style="cursor:pointer" @click="show_llm_lesson_plan_description"><k-icon color="light-blue" class="mr-2">fas fa-info-circle</k-icon>Lesson Plan Companion<k-icon class="k-lpe-dog-icon mx-2" style="margin-top:-5px">fas fa-dog</k-icon><!-- (<b class="red--text text--darken-3">BETA</b>)--></div>
					<k-checkbox v-if="show_lesson_variant_switcher" class="mt-0 pt-0" v-model="use_llm_for_new_lessons" @click="use_llm_clicked" hide-details off-icon="far fa-square" on-icon="fas fa-check-square"><template v-slot:label><span style="color:#444">Use Lesson Plan Companion <k-icon class="k-lpe-dog-icon" style="margin-top:-5px">fas fa-dog</k-icon> (<b class="red--text text--darken-3">BETA</b>)</span></template></k-checkbox>
				</div>
				<div :class="(use_enhanced_lesson_editor)?'k-lpe-lesson-edit-outer':'k-lesson-edit-outer'">
					<LessonEditorEnhanced ref="lesson_editor" v-if="use_enhanced_lesson_editor" :original_lesson="new_lesson" :lesson_class="new_lesson_class" :course_code="new_lesson_course_code" :lp_unit_id="new_lesson_lp_unit_id" @edit_lesson_cancel="create_lesson_cancel" @edit_lesson_saved="create_lesson_saved" />
					<LessonEditor ref="lesson_editor" v-else :original_lesson="new_lesson" :lesson_class="new_lesson_class" :course_code="new_lesson_course_code" :lp_unit_id="new_lesson_lp_unit_id" @edit_lesson_cancel="create_lesson_cancel" @edit_lesson_saved="create_lesson_saved" />
				</div>
			</k-card>
		</k-dialog>

		<BulkImport v-if="bulk_importer_showing" @dialog_close="bulk_importer_showing = false"/>
		<BulkActivityImport v-if="bulk_activity_editor_showing" :unit="home_unit" :collection="home_collection" @dialog_close="bulk_activity_editor_showing=false"></BulkActivityImport>
		<AILessonBuilder v-if="alba_showing" :unit="home_unit" :collection="home_collection" @dialog_close="alba_showing=false"></AILessonBuilder>
	</k-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ResourceEditor from '../resources/ResourceEditor'
import LessonView from '../lessons/LessonView'
import LessonEditor from '../lessons/LessonEditor'
import LessonEditorEnhanced from '../lessons/LessonEditorEnhanced'
import BulkActivityImport from './BulkActivityImport'
import BulkImport from './BulkImport.vue'
import AILessonBuilder from './AILessonBuilder'
import ResourceCollectionItem from '../resources/ResourceCollectionItem'

export default {
	name: 'ResourceSearch',
	components: { ResourceEditor, LessonView, LessonEditor, LessonEditorEnhanced, BulkActivityImport, BulkImport, AILessonBuilder, ResourceCollectionItem },
	props: {
		// req: { type: String, required: true },
		dialog_title: { type: String, required: false, default() { return 'Search Lessons, Activities, and other Resources'} },
		item_types: { required: false, default() { return ['resources','lessons','activities']} },
		existing_resources: { required: false, default() { return [] } },
		existing_lessons: { required: false, default() { return [] } },
		existing_activities: { required: false, default() { return [] } },
		home_lesson: { type: Object, required: false, default() { return null } },
		home_unit: { type: Object, required: false, default() { return null } },
		home_collection_base: { required: false, default() { return null } },
		// MC: No longer necessary?
		allow_add_from_home: { type: Boolean, required: false, default() { return false } },
		handle_edit_item_saved: { type: Boolean, required: false, default() { return false } },
		max_items: { required: false, default() { return 0 }},	// 0 = no max; 1 = choose one
		adding_to_lesson: { required: false, default() { return false }},	// send true when we launch from LessonEditor
		search_only: { required: false, default() { return false }},	// send true to disable the import shared / create new options

		default_source: { required: false, default() { return null }},	// send 'site', 'home_collection', or 'my' to default to searching there
		default_crit: { required: false, default() { return null }},	// send 'keywords' or 'standards' to default to that type of search

		// these are for external searches by standard
		default_framework_identifier: { required: false, default() { return '' }},
		starting_item_identifier: { required: false, default() { return '' }},

		// this is to start with a set of search_terms
		starting_search_terms: { required: false, default() { return '' }},
		restoreFocusElement: { required: false, default() { return undefined }},
	},
	data() { return {
		dialog_open: true,

		search_terms: '',
		current_server_search_terms: '',
		last_search_terms: '',
		search_term_res: [],

		satchel_showing: false,
		chosen_cfitem: null,
		chosen_framework_override: '',

		// searchable_items holds the "pool" of items we're showing
		searchable_items: [],
		searchable_category_count: {'1lesson':0, '2sparkl':0, '3resource':0},
		resources_by_source: null,
		show_resources_source_filter: false,

		// filtered_items shows items that match the current filters (including the search term filter)
		filtered_items: [],
		filtered_category_count: {'1lesson':0, '2sparkl':0, '3resource':0},

		standard_search_results: [],
		server_search_results: {},
		no_filter_search_text: '',

		keyword_search_asset_count_per_category: 100,

		selected_home_lesson: false,
		selected_home_collection: false,
		selected_my: false,
		selected_collection: '',

		selected_unit: null,

		return_to_cfitem: null,

		new_lesson: null,
		new_lesson_class: '',
		new_lesson_course_code: '',
		new_lesson_lp_unit_id: 0,

		open_sparkl_activity_embed_object: null,
		sparkl_closed_from_embed: false,
		new_activity: null,
		new_activity_saved: false,

		limit_menu_showing: false,

		search_result_icons: {
			resource: 'fas fa-link',
			activity: 'fas fa-star',
			lesson: 'fas fa-rectangle-list',
		},

		last_previewed_item: null,

		imported_items: [],
		new_resource_placeholder: null,

		items_per_page: 15,
		items_showing_count: {},
		potential_visible_search_results: 0,

		bulk_activity_editor_showing: false,
		bulk_importer_showing: false,
		alba_showing: false,
		match_scores: {},
		server_search_match_scores: {},
	}},
	computed: {
		...mapState(['user_info', 'site_config', 'all_courses_loaded', 'all_courses', 'lst', 'added_my_courses', 'asset_search_vectors', 'asset_search_term_vectors']),
		...mapGetters(['my_default_collection', 'signed_in', 'studentish_role', 'lti_chooser']),

		dialog_class() {
			if (this.lti_chooser) return 'k-search-dialog-lti-chooser'
			if (this.new_or_search=='search') return 'k-search-dialog-search'
			return 'k-search-dialog-new'
		},

		// we may need to load the full home_collection after the component loads, in which case the home_collection LP object in all_courses will change
		home_collection() {
			if (empty(this.home_collection_base)) return null
			return this.all_courses.find(x=>x.course_code == this.home_collection_base.course_code)
		},

		// determine whether or not to allow the user to toggle between the LPC and the "OG" lesson editor
		show_lesson_variant_switcher() {
			return U.show_lesson_variant_switcher(this.new_lesson?.lesson_id, this.home_collection?.course_code)
		},
		
		// now separately, determine whether or not to *use* the LPC or the OG lesson editor
		use_enhanced_lesson_editor() { return this.new_lesson.lp_variant=='B' },

		// and determine which version to use for new lessons
		use_llm_for_new_lessons: {
			get() { return U.use_llm_for_new_lessons(this.home_collection?.course_code) },
			set(val) { this.$store.commit('lst_set', ['use_llm_for_new_lessons', val]) }
		},

		citem_types() {
			// start with the item_types from props, but eliminate...
			let arr = []
			for (let t of this.item_types) {
				// any that we're not allowing via supported_content_types
				if (!this.site_config.supported_content_types.includes(t)) continue
				// and lessons, if we're in the lti_chooser
				if (t == 'lessons' && this.lti_chooser) continue
				arr.push(t)
			}
			return arr
		},
		server_search_types() {
			// these are the codes we send to the search service; we don't want to waste time searching for types we're not showing results for
			let arr = []
			if (this.citem_types.includes('lessons')) arr.push(0)
			if (this.citem_types.includes('activities')) arr.push(1)
			if (this.citem_types.includes('resources')) arr.push(2)
			return arr
		},

		cdialog_title() {
			let s = this.dialog_title
			// strip 'lessons' or 'activities' out of dialog title if we're not supporting them
			if (!this.site_config.supported_content_types.includes('lessons')) s = s.replace(/lessons/i, '')
			if (!this.site_config.supported_content_types.includes('activities')) s = s.replace(/activities/i, '')
			if (this.site_config.supported_content_types.length < 3) s = s.replace(/,/g, '')
			return s
		},
		resource_search_sort_by: {
			get() { return this.$store.state.lst.resource_search_sort_by },
			set(val) { this.$store.commit('lst_set', ['resource_search_sort_by', val]) }
		},
		resource_search_sort_by_created_at_order: {
			get() { return this.$store.state.lst.resource_search_sort_by_created_at_order },
			set(val) { this.$store.commit('lst_set', ['resource_search_sort_by_created_at_order', val]) }
		},
		new_or_search: {
			get() { 
				// if the search_only param is true, we only do search (duh)
				if (this.search_only) return 'search'
				return this.$store.state.lst.resource_selector_new_or_search 
			},
			set(val) { this.$store.commit('lst_set', ['resource_selector_new_or_search', val]) }
		},

		show_secondary_alignments: {
			get() { return this.$store.state.lst.resource_search_show_secondary_alignments },
			set(val) { this.$store.commit('lst_set', ['resource_search_show_secondary_alignments', val]) }
		},

		search_box_placeholder() {
			// TODO
			if (this.search_all) {
				if (this.standard_search && !this.chosen_cfitem) return 'Enter search terms for standards here, or click BROWSE at right'
				if (this.keyword_search && this.server_search_results.count == 0) return 'Enter keywords/search terms, then click SEARCH at right'
				return 'Enter additional search terms to filter results'
			} else {
				return 'Enter keywords/search terms to filter results'
			}
		},
		item_type_showing: {
			// '1lesson', '2sparkl', or '3resource'
			get() { 
				// if the value in lst isn't one of the currently-selected options, chose another one
				return this.$store.state.lst.search_item_type_showing 
			},
			set(val) { this.$store.commit('lst_set', ['search_item_type_showing', val]) }
		},
		search_crit: {
			// 'keywords' or 'standards'
			get() { return this.$store.state.lst.search_crit },
			set(val) { this.$store.commit('lst_set', ['search_crit', val]) }
		},

		sanitized_search_terms() {
			let st = $.trim(this.search_terms)
			if (empty(st)) return ''
			return U.sanitize_html(this.search_terms)
		},

		// we're doing a keyword search any time we're *not* searching all items, or if search_crit is set to 'keywords'
		keyword_search() { return this.search_crit == 'keywords' },
		// standard_search is the opposite
		standard_search() { return this.search_crit == 'standards' },

		// // we're doing a keyword search any time we're *not* searching all items, or if search_crit is set to 'keywords'
		// keyword_search() { return !this.search_all || this.search_crit == 'keywords' },
		// // standard_search is the opposite
		// standard_search() { return this.search_all && this.search_crit == 'standards' },

		subjects() {
			let arr = []
			for (let subject in this.$store.state.subjects) {
				// if we're searching by standards, only include subjects that have framework_identifiers specified
				if (this.standard_search && empty(this.$store.state.subjects[subject].framework_identifier)) {
					continue
				}
				arr.push({ value: subject, text: subject})
			}

			// if we're searching by keyword and searching all items, include an 'all' option
			if (this.search_all && this.search_crit == 'keywords') {
				arr.push({value: 'all', text: 'ALL SUBJECTS'})
			}

			return arr
		},
		chosen_framework_identifier() { 
			// this allows us to specify a framework for searching "externally"
			if (!empty(this.chosen_framework_override)) return this.chosen_framework_override

			if (!this.subject) return ''
			// if 'all' is selected, we'll return ''
			return this.$store.state.subjects[this.subject]?.framework_identifier ?? ''
		},

		search_all() { return !this.selected_home_lesson && !this.selected_home_collection && !this.selected_my && !this.selected_collection },
		no_results_help() {
			// show a message IF we have no searchable_items AND other conditions are met...
			if (this.searchable_items.length > 0) return ''

			if (this.standard_search && !empty(this.chosen_cfitem)) {
				return 'No items are aligned to the chosen standard.'
			}

			return ''
		},
		course_selection_array() {
			let arr = []
			for (let lp of this.all_courses) {
				// skip inactive courses if user isn't an admin for the course
				if (lp.active != 'yes' && !(lp.user_can_view_lp && lp.user_can_view_lp())) continue

				// if user doesn't have staff rights, skip PD collections
				if (this.studentish_role && lp.collection_type == 'pd') continue

				// skip home_collection
				if (this.home_collection && this.home_collection.course_code == lp.course_code) continue

				arr.push({value:lp, text: lp.title})
			}
			let priority_collections = []
			let added_courses = new Set()
			// 1st priority is the last viewed collections
			priority_collections.push(...arr.filter( ({value}) => {
				if (value.course_code == 'default') return false
				const exists = this.lst.last_collections_viewed.includes(`${value.course_code}`)
				if (exists && !added_courses.has(value.course_code)) {
					added_courses.add(value.course_code)
					return exists
				}
			}))
			// 2nd priority is the user created
			priority_collections.push(...arr.filter( ({value}) => {
				if (value.course_code == 'default') return false
				const exists = this.user_info.admin_rights.includes(`lp.course.${value.course_code}`)
				if (exists && !added_courses.has(value.course_code)) {
					added_courses.add(value.course_code)
					return exists
				}
			}))
			// 3rd priority is the added my courses
			priority_collections.push(...arr.filter( ({value}) => {
				if (value.course_code == 'default') return false
				const exists = this.added_my_courses.includes(`${value.course_code}`)
				if (exists && !added_courses.has(value.course_code)) {
					added_courses.add(value.course_code)
					return exists
				}
			}))
			const non_priority = arr.filter((e) => !priority_collections.includes(e))
			// sort alphabetically
			non_priority.sort((a,b)=>U.natural_sort(a.value.title, b.value.title))
			return [...priority_collections, ...non_priority]
		},

		unit_selection_array() {
			// don't show this menu if searching standards -- NO (6/6/2025)
			// if (this.search_crit == 'standards') return null

			// we show a unit select menu if we're showing a collection
			if (!this.selected_collection && !this.selected_home_collection) {
				return null
			}

			let c = this.selected_collection || this.home_collection
			if (!c) return null	// shouldn't happen

			let arr = []
			// start with an option for all units (this is the default); then add an item for each unit
			arr.push({value: null, text: 'ALL UNITS'})
			for (let unit of c.units) {
				if (empty(unit.title)) continue

				let text = unit.title
				if (!empty(unit.display_number)) text = `${unit.display_number} ${text}`
				arr.push({value: unit.lp_unit_id, text: text})
			}
			return arr
		},

		at_least_one_item_selected() {
			for (let item of this.searchable_items) {
				if (item.selected && !item.already_added) return true
			}
			return false
		},
		user_is_collection_editor() {
			if (!this.selected_collection) return false
			if (this.selected_collection.user_is_lp_admin()) return true
			return false
		},
		new_items_are_agency_sanctioned() {
			/** If Publisher enabled, return false */
			if (this.site_config.asset_manager.enabled) return false

			// if we're adding items to a lesson, match the lesson's agency_sanctioned flag
			if (this.home_lesson) return this.home_lesson.agency_sanctioned

			// if we don't have a home_collection, we can't tell if the item should be agency_sanctioned, so assume no
			if (!this.home_collection) return false

			// if we're adding items to a non-agency-sanctioned collection, the items should never be agency_sanctioned
			if (!this.home_collection.agency_sanctioned) return false

			// if we're adding items to a shadow unit, the items should never be agency_sanctioned
			if (!this.home_unit || this.home_unit.shadows_lp_unit_id) return false

			// if we get to here, items *should* be agency_sanctioned
			return true
		},

		// TEMP: whether or not to show the alba easter-egg button
		show_alba_btn() {
			// hiding as of 1/1/2025, because there are other ways to launch the LPC now
			return false
			// // always show to pepper
			// if (this.user_info.email.indexOf('pepper') == 0) return true
			// if (this.home_collection && this.site_config.alba_collections && this.site_config.alba_collections.length > 0 && this.site_config.alba_collections.includes(this.home_collection.course_code)) return true
			// return false
		},

		// TEMP: whether or not to show the gavs easter-egg button
		show_gavs_btn() {
			// don't show unless we're in the context of the unit editor
			if (!$(vapp.collection_unit_editor?.$el).is(':visible')) return false
			
			// show to commongoodlt emails, or the admin@henry.k12.ga.us email
			if (this.user_info.email.indexOf('commongoodlt') > -1) return true
			if (this.user_info.email == 'admin@henry.k12.ga.us') return true
			return false
		},
		
		// Whether or not to show the bulk importer easter-egg button
		show_import_btn() {
			// show to super users
			// if (vapp.has_admin_right('su')) return true
			// show to commongoodlt emails
			return this.user_info.email.indexOf('commongoodlt') > -1
		},

		collection_being_shown() {
			// this returns the collection whose content is currently being shown
			if (this.selected_collection) return this.selected_collection
			else if (this.selected_home_collection) return this.home_collection
			// if selected_my, use the users default collection
			else if (this.selected_my) return this.my_default_collection

			// if we get to here, we're not showing a collection
			return null
		},
		sandbox_being_shown() {
			// this could be true if either selected_my is true, or if the user is searching from the sandbox tile
			return this.collection_being_shown && (this.collection_being_shown == this.my_default_collection)
		},

		show_move_btn() {
			// we show the option to move items (as opposed to copying/aliasing) according to the following logic...

			// don't allow move if we're NOT in the 'search' mode of the interface (i.e. if we're in the 'import' or 'new' mode)
			if (this.new_or_search != 'search') return false

			// don't allow move if we're not adding to a lesson
			if (this.adding_to_lesson) return false

			// don't allow move if we don't have a home_collection (the home_collection is where we would move items *to*)
			if (!this.home_collection) return false

			// don't show the btn if no collection is selected from the "Search In" menu 
			// (if you find an item from a site-wide search, we don't know where to move it from, 
			// and we can't check to see if you're allowed to move from that collection)
			if (!this.collection_being_shown) return false

			// if we get to here, allow move from your sandbox (but see move_items_before_adding for exceptions)...
			if (this.selected_my) return true

			// ... otherwise, allow move if user is an editor of the collection_being_shown; 
			// otherwise don't allow move
			return this.collection_being_shown.user_is_lp_admin()
		},

		case_framework_for_collection_being_shown() {
			// if we're showing a collection, return the subject framework for that collection, if there is one
			if (!this.collection_being_shown) return ''
			return this.collection_being_shown.subject_case_identifier	// could be empty string
		},

		rci_option_overrides() { return (sr) => {
			// in lti_chooser mode, we just send lti_chooser: true through; that makes the ResourceCollectionItem just show preview and choose buttons
			if (this.lti_chooser) {
				return {lti_chooser: true}
			}

			let o = {
				// we used to disallow these first two; now let ResourceCollectionItem decide
				// edit: false,
				// copy_item_for_my_use: false,
				remove: false,
				unpublish: false,
				show_original: false,
				duplicate: false,
			}

			// let superusers edit from anywhwere
			if (vapp.has_admin_right('su')) {
				o.edit = true
				// TODO: this should probably only be true if this is an agency-sanctioned activity; but in any case we will retire "unpublish" as an option eventually
				o.unpublish = !empty(this.site_config.unpublished_items_collection)
			}

			// also, for sparkl activities, it's confusing if teachers can't edit their own activities from search
			if (sr.value?.type == 'sparkl') {
				// delete the o.edit property, so that ResourceCollectionItem will determine if they're allowed to edit based on the factors there
				// Note that if the user changes the title of the activity (for example), that title change won't currently be reflected in the resource
				delete o.edit
			}
			return o
		}},

		subject_chooser_available() {
			// if chosen_framework_override is set, don't show the subject chooser because the CASE framework is "locked" for some reason
			if (this.chosen_framework_override) return false
			// also, if case_framework_for_collection_being_shown is non-empty, don't show the subject chooser because we know we should be dealing with the subject tied to the collection
			if (this.case_framework_for_collection_being_shown) return false
			
			// if we're searching in a collection and search by keywords is selected, don't show the subject chooser because we're limiting to the items in the collection
			if (!this.search_all && this.keyword_search) return false

			// if we get to here show the subject chooser
			return true
		},

		subject: {
			get() { 
				// we only want to return a subject when we're searching all or searching by standard
				if (!(this.search_all || this.standard_search)) return ''
				// but we store subject in state.lst so we restore to the last subject the user chose
				return this.$store.state.lst.search_subject 
			},
			set(val) { 
				this.$store.commit('lst_set', ['search_subject', val]) 
			}
		},

		visible_search_results() {
			// side-effect: count the number of results that *could* be showing
			let n = 0

			// this is the array of search results we're currently showing, based on item_type_showing and items_showing_count[item_type_showing]
			let arr = []
			for (let sr of this.searchable_items) {
				if (sr.category != this.item_type_showing) continue
				++n
				if (arr.length < this.items_showing_count[this.item_type_showing]) {
					arr.push(sr)
				}
			}
			this.potential_visible_search_results = n
			return arr
		},

		chosen_framework_record() { 
			// this is used when searching by standards
			if (empty(this.chosen_framework_identifier)) return {}

			let fr = this.$store.state.framework_records.find(x=>x.lsdoc_identifier == this.chosen_framework_identifier)
			if (empty(fr)) console.warn('couldn’t get framework_record for ' + this.chosen_framework_identifier)
			return fr || {}
		},

		// resource sources this user wants to see; stored in lst
		// note that this will include a key for all sources the user has ever encountered, whether or not that source is represented in the current collection
		resources_source_filters: {
			get() { return this.$store.state.lst.resources_source_filters },
			set(val) { this.$store.commit('lst_set', ['resources_source_filters', val]) }
		},

		// count of total number of sources for the current search results
		resources_source_count() { 
			if (empty(this.resources_by_source)) return 0
			return Object.keys(this.resources_by_source).length
		},

		// count of total number of sources currently selected to view -- limited to the sources available in the current search results
		resources_selected_source_count() {
			if (empty(this.resources_by_source)) return 0
			let n = 0
			for (let source in this.resources_by_source) {
				if (this.resources_source_filters[source]) ++n
			}
			return n
		},

		// this is the icon to show at the top of the "FILTER BY SOURCE" menu, that allows you toggle all sources on/off (states are modeled on the GMail UI)
		toggle_all_sources_icon() {
			let all_checked = true, all_unchecked = true
			// note that if you select all here, it will turn all sources on, even for sources that aren't represented in the current collection
			for (let source in this.resources_source_filters) {
				if (this.resources_source_filters[source]) {
					all_unchecked = false
				} else {
					all_checked = false
				}

				// some are checked, some are not checked, so return minus
				if (!all_checked && !all_unchecked) {
					return 'fas fa-square-minus'
				}
			}
			if (all_checked) return 'fas fa-check-square'
			return 'far fa-square'	// all_unchecked
		},

		// count of total number of resources that match the source filters
		resources_showing_for_sources() {
			let n = 0
			for (let source in this.resources_by_source) {
				if (this.resources_source_filters[source]) {
					n += this.resources_by_source[source].length
				}
			}
			return n
		},

		// this is what we show in the "OTHER RESOURCES" tab for the count of resources available
		resource_count_string() {
			let s = ''

			// if filtering by source is enabled and some items are filtered out, show that
			if (this.site_config.enable_resource_filtering_by_source != 'no') {
				if (this.resources_showing_for_sources < this.searchable_category_count['3resource']) {
					s += `${this.resources_showing_for_sources}/`
				}
			}

			s += this.searchable_category_count['3resource']
			return s
		},

		show_secondary_alignments_checkbox() {
			if (this.standard_search && this.server_search_results?.count > 0) {
				// show the secondary alignments checkbox iff we have at least one secondary alignment
				return U.object_has_keys(this.server_search_results.secondary_alignments)
			}
		},
	},
	watch: {
		subject() {
			// when subject is selected/changed...

			// reset when subject is changed, preserving the search terms
			this.reset_search_all('preserve_search_terms')

			// TODO? if user chooses 'all', warn them that this is inefficienct

			// load the current subject's case doc if necessary
			this.load_framework_for_search()
		},

		// These watchers take care of what we need to do when user chooses a different filter value
		search_all() {
			this.limit_menu_showing = false
			if (this.search_all == true) {
				this.$store.commit('lst_set', ['selected_resource_filter', 'none'])

				// clear all match scores
				this.clear_all_match_scores()

				// load the current subject's case doc if necessary
				if (this.search_crit == 'standards') {
					this.load_framework_for_search()
				}
			}
		},
		selected_home_lesson() {
			this.limit_menu_showing = false
			if (this.selected_home_lesson == true) {
				this.selected_home_collection = false
				this.selected_collection = ''
				this.selected_my = false
				// store in selected_resource_filter so we'll go back to this filter when we come back to this dialog again
				this.$store.commit('lst_set', ['selected_resource_filter', 'home_lesson'])

				// clear all match scores
				this.clear_all_match_scores()
			}

			this.generate_searchable_items()
		},
		selected_home_collection() {
			this.limit_menu_showing = false
			if (this.selected_home_collection == true) {
				this.selected_home_lesson = false
				this.selected_my = false
				this.selected_collection = ''
				// store in selected_resource_filter so we'll go back to this filter when we come back to this dialog again
				this.$store.commit('lst_set', ['selected_resource_filter', 'home_collection'])

				// reset selected_unit when collection changes -- set to home_unit if we have it
				if (this.home_unit) this.selected_unit = this.home_unit.lp_unit_id
				else this.selected_unit = null

				// call this when collection changes
				this.adjust_item_type_showing_for_collection()

				// if we're searching in a collection and the collection is mapped to a subject/framework, select that subject/framework
				this.select_subject_for_collection_being_shown()

				// clear all match scores
				this.clear_all_match_scores()
			}

			// if we have to load standards-aligned assets for this collection, do so and wait for that to complete; that fn will call generate_searchable_items when it's done
			if (this.load_standards_aligned_assets_for_collection(this.home_collection)) {
				return
			}

			this.generate_searchable_items()
		},
		selected_my() {
			this.limit_menu_showing = false
			if (this.selected_my == true) {
				this.selected_home_lesson = false
				this.selected_home_collection = false
				this.selected_collection = ''

				// store in selected_resource_filter so we'll go back to this filter when we come back to this dialog again
				this.$store.commit('lst_set', ['selected_resource_filter', 'my'])

				// reset selected_unit and subject when sandbox chosen
				this.selected_unit = null
				this.subject = ''

				// we currently don't allow search by standards for my collection, so make sure we are searching by keywords
				this.search_crit = 'keywords'

				// call this when collection changes
				this.adjust_item_type_showing_for_collection()

				// clear all match scores
				this.clear_all_match_scores()
			}

			this.generate_searchable_items()
		},
		selected_collection() {
			this.limit_menu_showing = false
			if (this.selected_collection) {
				this.selected_home_lesson = false
				this.selected_home_collection = false
				this.selected_my = false
				this.$store.commit('lst_set', ['selected_resource_filter', this.selected_collection.course_code])

				// reset selected_unit when collection changes
				this.selected_unit = null

				// call this when collection changes
				this.adjust_item_type_showing_for_collection()

				// if we're searching in a collection and the collection is mapped to a subject/framework, select that subject/framework
				this.select_subject_for_collection_being_shown()

				// clear all match scores
				this.clear_all_match_scores()

				// if we have to load standards-aligned assets for this collection, do so and wait for that to complete; that fn will call generate_searchable_items when it's done
				if (this.load_standards_aligned_assets_for_collection(this.selected_collection)) {
					return
				}
			}

			this.generate_searchable_items()
		},
		resource_search_sort_by() { this.apply_resource_search_sort() },
		resource_search_sort_by_created_at_order() { this.apply_resource_search_sort() },

		chosen_cfitem() {
			if (empty(this.chosen_cfitem)) {
				// this.reset_search_all()
			} else {
				this.get_items_from_server_standard()
			}
		},

		search_crit() {
			let remembered_chosen_cfitem = this.chosen_cfitem

			// reset when search_crit is changed, preserving the search terms
			this.reset_search_all('preserve_search_terms')

			// if we're switching to standards...
			if (this.search_crit == 'standards') {
				// if we're searching in a collection and the collection is mapped to a subject/framework, select that subject/framework
				this.select_subject_for_collection_being_shown()

				// load the current subject's case doc if necessary
				this.load_framework_for_search()

				// also in this case, clear the search terms; otherwise this looks wonky
				// this.execute_search_clear()

				// and if we have a return_to_cfitem value, restore it
				if (!empty(this.return_to_cfitem)) {
					setTimeout(x=>this.chosen_cfitem = this.return_to_cfitem)
				}
			
			// else we're switching to keywords...
			} else {
				// try to remember the cfitem we were showing results for
				if (remembered_chosen_cfitem) this.return_to_cfitem = remembered_chosen_cfitem
			}

			// also reset chosen_framework_override when this is changed; this shows previously-hidden interface controls if the user started by searching for a non-subject-aligned framework
			this.chosen_framework_override = ''
		},

		selected_unit() {
			// when the selected unit changes, call generate_searchable_items to filter based on the unit
			this.generate_searchable_items()
		},

		search_terms() {
			// establish the debounce fn if necessary
			if (empty(this.search_terms_debounced)) {
				this.search_terms_debounced = U.debounce(function() {
					// if we're searching all by keywords and haven't gotten the first-stage results yet, return
					if (this.search_all && this.keyword_search && empty(this.current_server_search_terms)) return
					
					// otherwise call the service to get the vector for the given search terms if appropriate
					if (!empty(this.search_terms)) {
						if (this.sanitized_search_terms.length >= 4) {
							let search_term_vector = this.asset_search_term_vectors[this.sanitized_search_terms]
							// if we don't have the vector, call the asset_search_by_keywords service to get it
							if (!search_term_vector) {
								const payload = {
									user_id: this.user_info.user_id, 
									search_terms: this.sanitized_search_terms, 
									return_search_term_vector_only: 'yes',
									// this parameter is not currently used in this call, but send it in in case we need it later
									hide_unaligned_items_in_search: this.site_config.hide_unaligned_items_in_search,
								}

								// U.loading_start()
								U.ajax('asset_search_by_keywords', payload, result=>{
									// U.loading_stop()
									// console.warn('returned search_terms vector', result)
									this.$store.commit('set', [this.asset_search_term_vectors, payload.search_terms, result.vector])
									this.calculate_search_term_vector_matches()
								})

							// else call the fn to calculate matches
							} else {
								this.calculate_search_term_vector_matches()
							}
						}
					}
				}, 500)
			}
			// call the debounce fn
			this.search_terms_debounced()

			if (this.sanitized_search_terms.length < 4) {
				// if we get to here, we're searching a collection and we don't have search_terms (or it's too short to actually search), so clear match_scores
				this.match_scores = {}
				this.apply_resource_search_sort()
			}
		},
	},
	created() {
		vapp.search_component = this

		if (!this.all_courses_loaded) this.$store.dispatch('get_all_courses')
	},
	mounted() {
		this.previous_resource_search_sort_by = this.resource_search_sort_by

		if (this.default_source == 'home_collection') this.selected_home_collection = true
		else if (this.default_source == 'my') this.selected_my = true
		else if (this.default_source == 'site') this.select_none()
		else if (!empty(this.default_source)) {
			// if default_source is something else, it's a collection
			this.selected_collection = this.default_source

		// else try to restore to previously-selected filter
		} else this.restore_previously_selected_filter()

		// if default_crit was specified, deal with it
		if (!empty(this.default_crit)) this.search_crit = this.default_crit

		// if starting_keywords was specified, deal with it
		if (!empty(this.starting_search_terms)) {
			this.search_crit = 'keywords'
			// TODO: it's bad form to start with subject == all...
			this.subject = 'all'
			this.search_terms = this.starting_search_terms
			this.$nextTick(x=>{
				this.initiate_search_from_keyboard_or_search_icon()
			})
		}

		// if default_framework_identifier was specified, deal with it
		if (!empty(this.default_framework_identifier)) {
			this.search_crit = 'standards'

			/////////////////////////////////
			// fn to run once the lsdoc is loaded
			const default_framework_cb_fn = ()=>{
				// if the default_framework_identifier is one of our subject frameworks, set subject
				for (let subject in this.$store.state.subjects) {
					if (this.$store.state.subjects[subject].framework_identifier == this.default_framework_identifier) {
						this.subject = subject
					}
				}

				if (empty(this.subject)) {
					// if the default framework isn't a subject framework, set chosen_framework_override;
					// this will hide the "choose a subject" menu and "change standard" btn, but the user can just keep browsing in Satchel if they want to choose a different standard
					this.chosen_framework_override = this.default_framework_identifier
				}

				// note that setting the subject will trigger a watcher that will call reset_search_all, so set the starting cfitem on nextTick...
				if (this.starting_item_identifier) this.$nextTick(x=>{
					const cfitem = this.chosen_framework_record.json.CFItems.find(x=>x.identifier == this.starting_item_identifier)
					if (empty(cfitem)) { // shouldn't happen
						this.$alert('Error locating searched-for CASE item.')
						return
					}

					this.chosen_cfitem = {
						framework_identifier: this.default_framework_identifier,
						cfitem: cfitem
					}

					// record in return_to_cfitem here
					this.return_to_cfitem = this.chosen_cfitem
				})
			}
			/////////////////////////////////
			
			// load the default_framework_identifier case doc if necessary
			const fr = this.$store.state.framework_records.find(x=>x.lsdoc_identifier == this.default_framework_identifier)
			if (empty(fr) || !fr.framework_json_loaded) {
				U.loading_start()
				this.$store.dispatch('get_lsdoc', this.default_framework_identifier).then(x=> {
					U.loading_stop()
					default_framework_cb_fn()
				})
			} else {
				default_framework_cb_fn()
			}

		// else if we're going to be searching standards, load the current subject's case doc if necessary
		} else if (this.search_crit == 'standards') {
			this.load_framework_for_search()
		}

		// get lesson_masters if we haven't already done so
		this.$store.dispatch('get_lesson_masters')

		this.reset_items_showing_count()
		this.reset_server_search_results()
	},
	methods: {
		load_standards_aligned_assets_for_collection(collection) {
			if (empty(collection.lp_id) || !collection.units_fully_loaded()) {
				U.loading_start()
				let params = {
					course_code: collection.course_code,
					force_reload: true
				}
				this.$store.dispatch('get_learning_progression', params).then((found)=>{
					U.loading_stop()
					let new_collection = this.all_courses.find(x=>x.course_code == collection.course_code)
					if (this.selected_collection) this.selected_collection = new_collection
					// else if (this.home_collection) this.home_collection = new_collection

					// re-call load_standards_aligned_assets_for_collection once collection is loaded
					this.load_standards_aligned_assets_for_collection(new_collection)
				})
				return true
			}

			// when we get to here, collection is fully loaded
			// if any units in the selected course don't have standards_aligned_assets_loaded, load assets for all units
			for (let u of collection.units) {
				if (!u.standards_aligned_assets_loaded) {
					collection.get_standards_aligned_assets().then(x=>{
						// when this completes, call generate_searchable_items
						this.generate_searchable_items()
					})
					// return true to tell the caller that standards-aligned assets need to be loaded
					return true
				}
			}
			return false
		},

		search_source_clicked(source) {
			if (source == 'site') this.select_none()
			else if (source == 'home_lesson') this.selected_home_lesson = true
			else if (source == 'home_collection') this.selected_home_collection = true
			else if (source == 'my') this.selected_my = true
			// any other value is a collection_id
			else this.selected_collection = source
		},

		set_resource_search_sort_order() {
			if (this.previous_resource_search_sort_by == 'created_at') {
				if (this.resource_search_sort_by_created_at_order == 'desc') this.$store.commit('lst_set', ['resource_search_sort_by_created_at_order', 'asc'])
				else this.$store.commit('lst_set', ['resource_search_sort_by_created_at_order', 'desc'])
			}
			this.previous_resource_search_sort_by = 'created_at'
		},

		// select the subject for the currently-showing collection, if there is one
		select_subject_for_collection_being_shown() {
			// if a collection is not showing, or that collection doesn't have a subject framework, nothing to do
			if (!this.case_framework_for_collection_being_shown) return

			// otherwise look for the subject
			for (let subject in this.$store.state.subjects) {
				if (this.$store.state.subjects[subject].framework_identifier == this.case_framework_for_collection_being_shown) {
					this.subject = subject
				}
			}
		},

		load_selected_item_vectors() {
			return new Promise((resolve, reject)=>{
				// we do this unless we're searching all by keywords -- in which case we'll return the items' vectors with the initial asset_search_by_keywords call
				if (this.search_all && this.keyword_search) {
					resolve()
					return
				}

				// create collection of item_ids that we need vectors for
				let asset_ids_to_get = []
				for (let item of this.searchable_items) {
					if (empty(this.asset_search_vectors[item.item_id])) {
						asset_ids_to_get.push(item.item_id)
					}
				}

				// if we already have all the vectors, return
				if (asset_ids_to_get.length == 0) {
					resolve()
					return
				}

				// call the asset_search_by_keywords service to get the vectors
				const payload = {
					user_id: this.user_info.user_id, 
					asset_ids_to_get: JSON.stringify(asset_ids_to_get),
					return_asset_vectors_only: 'yes',
					// this parameter is not currently used in this call, but send it in in case we need it later
					hide_unaligned_items_in_search: this.site_config.hide_unaligned_items_in_search,
				}

				// U.loading_start()
				U.ajax('asset_search_by_keywords', payload, result=>{
					// U.loading_stop()
					// console.warn('returned', result)
					for (let v of result.vectors) {
						this.$store.commit('set', [this.asset_search_vectors, v.asset_id, JSON.parse(v.vector)])
					}
					
					// then resolve the promise
					resolve()
				})
			})
		},

		// this calculates, when appropriate, vector matches between assets and search terms
		calculate_search_term_vector_matches() {
			this.match_scores = {}

			// if we don't have search terms, or we don't have a vector for the current search terms, we can't do this
			if (empty(this.sanitized_search_terms)) return
			let st_vector = this.asset_search_term_vectors[this.sanitized_search_terms]
			if (empty(st_vector)) return

			// load item vectors if needed, then...
			this.load_selected_item_vectors().then(x=>{
				// calculate the match scores
				let o = {}
				for (let item of this.searchable_items) {
					let item_vector = this.asset_search_vectors[item.item_id]
					if (item_vector) {
						let cs = U.cosine_similarity(st_vector, item_vector)
						o[item.item_id] = (cs > 0) ? Math.round(cs * 1000) : 0
					}
				}
				this.match_scores = o

				// whenever we do this, sort
				this.apply_resource_search_sort()
			})
		},

		clear_all_match_scores() {
			this.match_scores = {}
			this.server_search_match_scores = {}
		},

		apply_resource_search_sort() {
			// Group the input array by category(Lesson, Activity, Resource), then alphabetically or by created_at date within the category
			this.searchable_items.sort((a, b) => {
				// const category_comparison = U.natural_sort(a.category, b.category)
				// if (category_comparison !== 0) return category_comparison

				// filtered_items go on top
				if (this.filtered_items.includes(a)) {
					if (!this.filtered_items.includes(b)) return -1
				} else if (this.filtered_items.includes(b)) return 1

				// if we have match_scores, use them. This should be the case if either a) we're searching anything other than the whole site, or b) search_all and we're doing a "second-stage" filtering search
				if (!empty(this.match_scores[b.item_id]) && !empty(this.match_scores[a.item_id])) return this.match_scores[b.item_id] - this.match_scores[a.item_id]

				// else if we have server_search_match_scores, use them. This should be the case if we've done a search_all
				if (!empty(this.server_search_match_scores[b.item_id]) && !empty(this.server_search_match_scores[a.item_id])) return this.server_search_match_scores[b.item_id] - this.server_search_match_scores[a.item_id]

				// if sorting by created_at date...
				if (this.sandbox_being_shown && this.resource_search_sort_by == 'created_at') {
					if (this.resource_search_sort_by_created_at_order == 'asc') {
						return U.natural_sort(b.created_at + '', a.created_at + '')
					} else {
						return U.natural_sort(a.created_at + '', b.created_at + '')
					}
				}

				// default to alpha sort
				return U.natural_sort(a.text, b.text)
			})
		},
		// restore the filter the user previously selected the last time they were adding content
		restore_previously_selected_filter() {
			if (this.$store.state.lst.selected_resource_filter == 'none') {
				this.selected_home_lesson = false
				this.selected_home_collection = false
				this.selected_my = false
				this.selected_collection = ''

			} else if (this.$store.state.lst.selected_resource_filter == 'home_lesson') {
				this.selected_home_lesson = (this.home_lesson != null)	// true if we were given a home lesson; false otherwise
				this.selected_home_collection = false
				this.selected_my = false
				this.selected_collection = ''

			} else if (this.$store.state.lst.selected_resource_filter == 'home_collection' || this.$store.state.lst.selected_resource_filter === this.home_collection?.course_code) {
				this.selected_home_lesson = false
				this.selected_home_collection = (this.home_collection != null)	// true if we were given a home course; false otherwise
				this.selected_my = false
				this.selected_collection = ''

			} else if (this.$store.state.lst.selected_resource_filter == 'my') {
				this.selected_home_lesson = false
				this.selected_home_collection = false
				this.selected_my = true
				this.selected_collection = ''

			} else {
				this.selected_home_lesson = false
				this.selected_home_collection = false
				this.selected_my = false
				this.selected_collection = this.all_courses.find(x=>x.course_code == this.$store.state.lst.selected_resource_filter) ?? ''
			}

			// if we're not allowing the user to add other resources from the home collection/unit, make sure we don't start with these options selected (v-ifs above will make sure the options aren't allowed to select)
			if (!this.allow_add_from_home) {
				if (this.selected_my && this.home_collection == this.my_default_collection) {
					this.select_none()
				} else if (this.selected_home_lesson || this.selected_home_collection) {
					this.select_none()
				} else if (this.home_collection) {
					if (this.selected_collection && this.selected_collection.course_code == this.home_collection.course_code) this.select_none()
				}
			}
		},

		select_none() {
			// clear all the selected_xx values, so that we're searching everything in cureum
			this.selected_home_lesson = false
			this.selected_home_collection = false
			this.selected_my = false
			this.selected_collection = ''
		},

		matches_search(s) {
			// accept either a single string or an array
			if (!$.isArray(s)) s = [s]
			if (U.strings_match_search_term_res(this.search_term_res, s)) {
				return true
			}
			return false
		},

		// this is called when the user is searching all items and clicks "New Search"
		reset_search_all(flag) {
			// console.warn('reset', this.current_server_search_terms)
			let ost = this.search_terms
			this.execute_search_clear()
			if (flag == 'preserve_search_terms') {
				this.search_terms = ost
			} else {
				this.search_terms = this.current_server_search_terms
				this.current_server_search_terms = ''
			}
			this.chosen_cfitem = null
			this.reset_server_search_results()
			this.generate_searchable_items()
		},

		reset_items_showing_count() {
			this.items_showing_count = {
				'1lesson': this.items_per_page,
				'2sparkl': this.items_per_page,
				'3resource': this.items_per_page
			}
		},

		reset_server_search_results() {
			this.server_search_results = { 
				resources:[], 
				activities:[], 
				lessons:[], 
				secondary_alignments:{},
				count: 0 
			}
		},

		search_field_keyup(evt) {
			// when enter key is tapped, call initiate_search_from_keyboard_or_search_icon
			this.reset_items_showing_count()
			if (evt.keyCode == 13) this.initiate_search_from_keyboard_or_search_icon()
			else this.execute_search()
		},

		initiate_search_from_keyboard_or_search_icon() {
			// if we're *not* filtering by an lp or my resources and we're searching by keyword, this is where we poll the server for potential search results
			if (this.search_all && this.keyword_search) {
				// but if we've already done the "first-stage" search, don't do this again here
				if (!empty(this.current_server_search_terms)) {
					// instead call execute_search
					this.execute_search()
					return
				}
				this.get_items_from_server_keywords()
			}
			// else execute search? maybe not, since we would have executed based on the last thing you typed
		},

		async browse_standards(cfitem) {
			// if the button to do this is clicked, the user must have chosen a subject
			let data = { 
				framework_identifier: this.chosen_framework_identifier, 
				item_identifier: '', 
				// set this to true to show the asset counts btn in item tiles
				show_asset_counts_in_item_tiles: true,
			}

			// if we really received a cfitem (not an event), start with it
			if (cfitem.identifier) {
				data.item_identifier = cfitem.identifier

			// else if we're showing a collection that maps to a cfitem, open to that cfitem
			} else if (this.collection_being_shown?.course_case_identifier) {
				data.item_identifier = this.collection_being_shown.course_case_identifier
			}

			let show_data = { 
				// set embed_hide_callback_fn to ... when the user closes the chooser
				embed_hide_callback_fn: ()=>{ this.satchel_showing = false },
				// set hide_fn to hide the standards chooser if/when the search dialog is no longer visible
				hide_fn: ()=>{ return ($('.k-search-card').is(':visible') == false) },
			}

			this.satchel_showing = true
			try {
				await vapp.$refs.satchel.execute('show', show_data)
				await vapp.$refs.satchel.execute('load_framework', data)
				await vapp.$refs.satchel.execute('transmit_asset_counts', data)	// this just needs framework_identifier, which is already in data
				vapp.$refs.satchel.execute('chooser', {chooser_mode: true}).then((chosen_item) => {
					// console.warn(chosen_item)
					this.choose_cfitem_for_search(chosen_item)
				})
			} catch (e) {
				this.satchel_showing = false
			}
		},

		choose_cfitem_for_search(cfitem) {
			// add framework_identifier if not part of cfitem
			if (empty(cfitem.framework_identifier)) {
				cfitem = {
					framework_identifier: this.chosen_framework_identifier,
					cfitem: cfitem
				}
			}

			// remember this.current_server_search_terms
			this.current_server_search_terms = this.search_terms
			
			// set chosen_cfitem
			this.chosen_cfitem = cfitem

			// make sure satchel isn't showing (?)
			this.satchel_showing = false
			vapp.$refs.satchel.execute('hide')
		},

		rendered_cfitem(cfitem) {
			// allow for cfitem to be a "raw" cfitem or an object containing a cfitem
			if (cfitem.cfitem) cfitem = cfitem.cfitem

			let s = '<div class="d-flex">'
			if (cfitem.humanCodingScheme) s += `<p><b class="mr-2"><nobr>${cfitem.humanCodingScheme}</nobr></b></p>`

			let its = ''
			const item_type = U.item_type(cfitem)
			const el = U.grade_level_display(cfitem.educationLevel).replace(/\b0/g, '')
			if (item_type || el) {
				its += ' <i style="font-size:0.8em">('
				if (item_type) {
					its += `<nobr>${item_type}</nobr>`
				}
				if (el) {
					if (item_type) its += ', '
					its += `<nobr>Grade ${el}</nobr>`
				}
				its += ')</i>'
			}

			s += `<div>${U.marked_latex(cfitem.fullStatement + its)}</div>`
			s += '</div>'
			return s
		},

		// this loads the current subject's framework, if it isn't already fully loaded
		load_framework_for_search() {
			this.$nextTick(x=>{
				if (this.chosen_framework_identifier) {
					const fr = this.$store.state.framework_records.find(x=>x.lsdoc_identifier == this.chosen_framework_identifier)
					if (empty(fr) || !fr.framework_json_loaded) {
						// this should be quick, so we shouldn't need to show the loader
						// U.loading_start()
						this.$store.dispatch('get_lsdoc', this.chosen_framework_identifier).then(x=> {
							// U.loading_stop()
						})
					}
				}
			})
		},

		execute_search() {
			// establish the debounce fn if necessary
			if (empty(this.execute_search_debounced)) {
				this.execute_search_debounced = U.debounce(function() {
					this.search_term_res = U.create_search_re(this.search_terms)

					// if we're searching everything (no collection is selected), doing a standards search, and haven't chosen a standard, search through standards for the selected subject
					if (this.search_all && this.standard_search && this.subject && !this.chosen_cfitem) {
						// if no re's (e.g. because search_terms is empty), just clear filtered_items
						if (this.search_term_res.length == 0) {
							this.standard_search_results = []
							return
						}

						if (empty(this.chosen_framework_record.json)) {
							console.error('execute_search for standards, but we don’t have a framework_record!')	// shouldn't happen
							return
						}

						let arr = []
						for (let cfitem of this.chosen_framework_record.json.CFItems) {
							if (cfitem.humanCodingScheme && this.matches_search(cfitem.humanCodingScheme)) arr.push(cfitem)
							else if (this.matches_search(cfitem.fullStatement)) arr.push(cfitem)
						}
						this.standard_search_results = arr
						return
					}

					let arr = []
					this.filtered_category_count = {'1lesson':0, '2sparkl':0, '3resource':0}
					for (let item of this.searchable_items) {
						// if we don't have search_terms, everything goes in filtered_items
						// else put in filtered_items if the terms match, for this asset, the text_lc, or the humanCodingScheme for any standards aligned to this asset
						let sarr = [item.text_lc]
						if (item.value.standards?.length > 0) for (let standard of item.value.standards) {
							if (!empty(standard.humanCodingScheme)) sarr.push(standard.humanCodingScheme)
						}

						// if search terms are in the title (or description?) itself, put in filtered items
						if (empty(this.search_terms) || this.matches_search(sarr)) {
							arr.push(item)
							++this.filtered_category_count[item.category]
						}
					}
					this.filtered_items = arr

					this.apply_resource_search_sort()
				}, 15)
			}
			// call the debounce fn
			this.execute_search_debounced()
		},

		asset_css(item) {
			if (this.filtered_items.length == this.searchable_items.length) return ''
			const is_filtered = this.filtered_items.includes(item)
			return 'k-resource-search-in-filtered-items-' + is_filtered
		},

		asset_style(item, i) {
			// if all assets are showing, no fade
			if (this.potential_visible_search_results == this.visible_search_results.length) return ''

			// if at least x items are visible, fade the final y visible items
			if (this.visible_search_results.length < (this.items_per_page - 5)) return ''
			let from_end = this.visible_search_results.length - i
			if (from_end >= 5) return ''
			return `opacity:${(from_end+1)/6};`
		},

		execute_search_clear() {
			this.search_terms = ''
			this.last_search_terms = ''
			this.filtered_items = []
			this.search_term_res = []
			this.reset_items_showing_count()
			this.match_scores = {}
			this.execute_search()
		},

		get_items_from_server_keywords() {
			this.reset_server_search_results()

			if (this.search_terms.length < 4) {
				this.$alert('Please enter at least four characters in your search string.')
				return
			}

			const payload = {
				user_id: this.user_info.user_id, 
				asset_count_per_category: this.keyword_search_asset_count_per_category,
				search_terms: U.sanitize_html(this.search_terms), 
				types: this.server_search_types, 
				hide_unaligned_items_in_search: this.site_config.hide_unaligned_items_in_search,
			}

			// include a subject if one is chosen
			if (!empty(this.subject) && this.subject != 'all') {
				payload.subjects = [this.subject]
			}

			// include a collection if one is chosen
			if (this.selected_collection) payload.search_collection_id = this.selected_collection.lp_id
			else if (this.selected_home_collection) payload.search_collection_id = this.home_collection.lp_id

			// include searchable_items if needed (e.g. sandbox??)
			if (!this.search_all && this.searchable_items.length > 0) {
				payload.searchable_item_ids = JSON.stringify(this.searchable_items.map(item => item.item_id))
			}

			U.loading_start()
			U.ajax('asset_search_by_keywords', payload, result=>{
				U.loading_stop()

				// set current_server_search_terms to the terms we just searched for, and clear search terms
				this.current_server_search_terms = this.search_terms
				this.search_terms = ''

				// store the match scores we get from the server in server_search_match_scores; also store the vectors in asset_search_vectors
				let server_search_match_scores = {}
				this.server_search_results.count = 0
				if (result.top_lessons) {
					for (let asset_row of result.top_lessons) {
						server_search_match_scores[asset_row.asset_id] = (asset_row.match_val > 0) ? asset_row.match_val : 0
						this.$store.commit('set', [this.asset_search_vectors, asset_row.asset_id, JSON.parse(asset_row.vector)])
						asset_row.asset_data.lesson_id = asset_row.asset_id
						this.server_search_results.lessons.push(new Lesson(asset_row.asset_data))
						++this.server_search_results.count
					}
				}
				if (result.top_activities) {
					for (let asset_row of result.top_activities) {
						server_search_match_scores[asset_row.asset_id] = (asset_row.match_val > 0) ? asset_row.match_val : 0
						this.$store.commit('set', [this.asset_search_vectors, asset_row.asset_id, JSON.parse(asset_row.vector)])
						asset_row.asset_data.resource_id = asset_row.asset_id
						this.server_search_results.activities.push(new Resource(asset_row.asset_data))
						++this.server_search_results.count
					}
				}
				if (result.top_resources) {
					for (let asset_row of result.top_resources) {
						server_search_match_scores[asset_row.asset_id] = (asset_row.match_val > 0) ? asset_row.match_val : 0
						this.$store.commit('set', [this.asset_search_vectors, asset_row.asset_id, JSON.parse(asset_row.vector)])
						asset_row.asset_data.resource_id = asset_row.asset_id
						this.server_search_results.resources.push(new Resource(asset_row.asset_data))
						++this.server_search_results.count
					}
				}
				this.server_search_match_scores = server_search_match_scores

				this.generate_searchable_items()
			})
		},

		get_items_from_server_standard() {
			this.reset_server_search_results()

			// get list of CFItems to retrieve standards for. start with the chosen item, then add any children of this item
			let cfitem_identifiers = []

			let top_node = this.chosen_framework_record?.tree_nodes_hash[this.chosen_cfitem.cfitem.identifier]
			if (empty(top_node)) {
				// this shouldn't happen, but if we don't have a node, we can just try to get items for the specified identifier
				cfitem_identifiers = [this.chosen_cfitem.cfitem.identifier]
			} else {
				// recursive fn to add a "branch" of nodes
				let add_items = (node) => {
					cfitem_identifiers.push(node.cfitem.identifier)
					for (let child_node of node.children) {
						add_items(child_node)
					}
				}
				add_items(top_node)
			}

			const payload = {
				user_id: this.user_info.user_id, 
				search_strings: JSON.stringify([this.search_terms]), 
				types: this.server_search_types, 
				cfitem_identifiers: cfitem_identifiers,
				// this parameter is not currently used for standard search, but send it in in case we need it later
				hide_unaligned_items_in_search: this.site_config.hide_unaligned_items_in_search,
			}
			// I don't think there will ever be any need to include searchable_item_ids here...

			U.loading_start()
			U.ajax('asset_search_by_standards', payload, result=>{
				U.loading_stop()

				// set current_server_search_terms to the terms we just searched for, and clear search terms
				this.current_server_search_terms = this.search_terms
				this.search_terms = ''

				// note: when we search by standards, we receive an 'is_secondary' flag for each returned asset; store this flag in server_search_results.secondary_alignments, indexed by id
				this.server_search_results.count = 0
				if (result.top_lessons) {
					for (let asset_row of result.top_lessons) {
						asset_row.asset_data.lesson_id = asset_row.asset_id
						this.server_search_results.lessons.push(new Lesson(asset_row.asset_data))
						++this.server_search_results.count
						if (asset_row.asset_data.is_secondary == 1) this.server_search_results.secondary_alignments[asset_row.asset_id] = true
					}
				}
				if (result.top_activities) {
					for (let asset_row of result.top_activities) {
						asset_row.asset_data.resource_id = asset_row.asset_id
						this.server_search_results.activities.push(new Resource(asset_row.asset_data))
						++this.server_search_results.count
						if (asset_row.asset_data.is_secondary == 1) this.server_search_results.secondary_alignments[asset_row.asset_id] = true
					}
				}
				if (result.top_resources) {
					for (let asset_row of result.top_resources) {
						asset_row.asset_data.resource_id = asset_row.asset_id
						this.server_search_results.resources.push(new Resource(asset_row.asset_data))
						++this.server_search_results.count
						if (asset_row.asset_data.is_secondary == 1) this.server_search_results.secondary_alignments[asset_row.asset_id] = true
					}
				}

				this.generate_searchable_items()
			})
		},

		generate_searchable_items() {
			this.reset_items_showing_count()

			// establish the debounce fn if necessary
			if (empty(this.generate_searchable_items_debounced)) {
				this.generate_searchable_items_debounced = U.debounce(function(x) {

					// this fn is for traversing a resource collection generated from a common cartridge (i.e. HMH resources in HenryConnects)
					function traverse(resource_arr, collection_id, node, collection_inclusions, parent_included) {
						// we assume here that each node is *either* a resource (where the resource_id is specified by 'r') or a "folder" (with children in 'c')
						if (!empty(node.r)) {
							// if this resource's parent is included, include the resource
							if (parent_included) resource_arr.push(new Resource({
								resource_id: node.r,
								type: 'collection_item',
								teacher_facing: (node.i == 1),	//
								description: node.t,
							}))

						} else if (!empty(node.c)) {
							// this is a folder; if it is either implicitly or explicitly included, its child resources should be included
							let node_included_explicitly = empty(collection_inclusions) || !empty(collection_inclusions.find(x=>x==node.f))	// node.f = identifier, from CC file
							let node_included_implicitly = !node_included_explicitly && parent_included

							for (let child of node.c) {
								// traverse child; parent_included is true if nn is either explicitly or implicitly included
								traverse(resource_arr, collection_id, child, collection_inclusions, (node_included_explicitly || node_included_implicitly))
							}
						}
					}

					// fn for adding an item to the the return array
					let add_item = (item, type, text, lp_unit_id = 0) => {
						let o = {
							value: item
						}

						if (type == 'resource') {
							// only add each item once
							if (arr.find(x=>x.value.resource_id == item.resource_id)) return
							// also skip duplicate urls for resources
							if (!empty(item.url) && arr.find(x=>x.value.url == item.url)) return
							// mark items that already exist
							if (this.existing_resources.find(x=>x.resource_id == item.resource_id)) o.already_added = true
							// add item_id
							o.item_id = item.resource_id

							// sparkl resources go in the sparkl category
							if (item.type == 'sparkl') o.category = '2sparkl'
							else {
								o.category = '3resource'
								// segment resources into content_source categories, applying custom logic for this instance
								if (!this.add_resource_by_source(rbs, o)) {
									// if add_resource_by_source returns false, don't add it at all
									return
								}
							}
						}
						if (type == 'lesson') {
							if (arr.find(x=>x.value.lesson_id == item.lesson_id)) return
							if (this.existing_lessons.find(x=>x.lesson_id == item.lesson_id)) o.already_added = true
							o.item_id = item.lesson_id
							o.category = '1lesson'
						}
						if (type == 'activity') {
							if (arr.find(x=>x.value.resource_id == item.resource_id)) return
							if (this.existing_activities.find(x=>x.resource_id == item.resource_id)) o.already_added = true
							o.item_id = item.resource_id
							o.category = '2sparkl'
						}
						o.type = type
						o.text = text
						o.created_at = item.created_at
						o.lp_unit_id = lp_unit_id
						o.text_lc = o.text.toLowerCase()
						o.selected = o.already_added
						arr.push(o)

						// if the incoming text isn't identical to the asset's lesson_title/description, set title_override
						// (we set title_override separately to prevent overriding the user's title for a possible "copy for my use" of the asset)
						if (text != (item.lesson_title || item.description)) o.title_override = text

						// add to searchable_category_count as we go
						this.searchable_category_count[o.category] += 1
					}

					this.searchable_category_count = {'1lesson':0, '2sparkl':0, '3resource':0}
					this.resources_by_source = null
					let rbs = {}
					let arr = []

					// if we just did a server-side search, show those
					if (this.server_search_results?.count > 0) {
						for (let l of this.server_search_results.lessons) {
							// if we're doing a standard_search and we're not showing secondary alignments, filter them out
							if (this.standard_search && !this.show_secondary_alignments) {
								if (this.server_search_results.secondary_alignments[l.lesson_id]) continue
							}

							add_item(l, 'lesson', l.lesson_title)

							// resources from the lesson
							// TODO: if we're showing these...
							for (let r of l.resources) {
								add_item(r, 'resource', `${r.description}<span class="k-full-resource-search-result-from-lesson">(from Lesson)</span>`)
							}
						}

						for (let a of this.server_search_results.activities) {
							// if we're doing a standard_search and we're not showing secondary alignments, filter them out
							if (this.standard_search && !this.show_secondary_alignments) {
								if (this.server_search_results.secondary_alignments[a.resource_id]) continue
							}
							add_item(a, 'activity', a.description)
						}

						for (let r of this.server_search_results.resources) {
							// if we're doing a standard_search and we're not showing secondary alignments, filter them out
							if (this.standard_search && !this.show_secondary_alignments) {
								if (this.server_search_results.secondary_alignments[r.resource_id]) continue
							}
							add_item(r, 'resource', r.description)	//  ($2)
						}

					// assets for a collection, including the user's sandbox
					} else if (this.selected_collection || this.selected_home_collection || this.selected_my) {
						let lp = this.collection_being_shown
						
						for (let unit of lp.units) {
							// if we have a selected unit, only include items for that unit
							if (!empty(this.selected_unit)) {
								if (unit.lp_unit_id != this.selected_unit) continue
							}
							// ? add the unit title for collections (not selected_my, which is the sandbox)
							let unit_title = ''
							// if (!this.selected_my && !empty(unit.title)) {
							// 	unit_title = `<span class="k-full-resource-search-result-unit">${unit.title}</span> `
							// }

							// resources
							for (let r of unit.resources) {
								if (r.placeholder == true) continue		// don't add the placeholder item
								add_item(r, 'resource', `${r.description}${unit_title}`, unit.lp_unit_id)
							}

							// lessons, and resources in lessons
							for (let l of unit.lessons) {
								add_item(l, 'lesson', `${l.lesson_title}${unit_title}`, unit.lp_unit_id)

								// TODO: do we need to load the full lessons in order to get the list of resources??
								for (let r of l.resources) {
									// ${unit_title}
									add_item(r, 'resource', `${r.description}<span class="k-full-resource-search-result-from-lesson">(from Lesson)</span>`, unit.lp_unit_id)
								}
								// TODO: lessons can now include other lessons
							}

							// add standards_aligned_assets if we have them for the unit
							for (let a of unit.standards_aligned_assets) {
								// note that the items here aren't lessons/resources directly
								if (!arr.find(x=>x.item_id == a.asset_id)) {
									if (a.asset_type == 'lesson') {
										if (!a.lesson) {
											// console.warn(`standards-aligned lesson ${a.asset_id} not loaded`)
											continue
										}
										add_item(a.lesson, 'lesson', `${a.lesson.lesson_title}${unit_title}`, unit.lp_unit_id)
									} else {
										if (!a.resource) {
											// console.warn(`standards-aligned resource ${a.asset_id} not loaded`)
											continue
										}
										add_item(a.resource, 'resource', `${a.resource.description}${unit_title}`, unit.lp_unit_id)
									}
								}
							}
						}
						
						// LEGACY: add course_wide_resources (I don't think we have these any more)
						for (let r of lp.course_wide_resources) {
							add_item(r, 'resource', `Course-Wide: ${r.description}`)
						}

						// ?? add common cartridge items if there
						for (let rc of lp.resource_collections) {
							let col_arr = []
							traverse(col_arr, rc.resource_id, rc.collection_json, null, true)
							for (let r of col_arr) {
								add_item(r, 'resource', `TEXTBOOK: ${r.description}`)
							}
						}

						// TODO?: if this is an agency-sanctioned repo, add items from the user's "shadow units"

					} else if (this.selected_home_lesson) {
						for (let r of this.home_lesson.resources) {
							add_item(r, 'resource', r.description)
						}
						for (let r of this.home_lesson.lessons) {
							add_item(r, 'lesson', r.lesson_title)
						}

					}

					if (U.object_has_keys(rbs)) {
						// finalize rbs object, applying custom logic for this instance
						this.finalize_rbs(rbs)
					}

					// at least for now, cull duplicates
					// note that we have to do this before filtering by source, because cull_duplicate_searchable_items sets searchable_category_count, which we want to include resources filtered out by source
					arr = this.cull_duplicate_searchable_items(arr)

					// filter resources by source
					let arr2 = []
					for (let item of arr) {
						if (item.source) {
							if (!this.resources_source_filters[item.source]) continue
						}
						arr2.push(item)
					}

					// finally set searchable_items
					this.searchable_items = arr2

					this.execute_search()
				}, 10)
			}
			
			// call the debounce fn
			this.generate_searchable_items_debounced()
		},

		add_resource_by_source(rbs, o) {
			// if site_config.enable_resource_filtering_by_source is enabled...
			if (this.site_config.enable_resource_filtering_by_source == 'no') {
				return true
			}

			// segment resources into content_source categories, applying custom logic for this instance
			// (currently we just use the same logic for all instances)
			let source = o.value.extensions?.content_source || 'Other'
			if (o.value.url.indexOf('goopennc.oercommons') > -1) {
				// if (source != 'other') console.warn('goopen not other: ' + source)

				// try to weed out rethink resources from goopen
				if (o.value.description.indexOf('Rethink') == 0) {
					return false
				}
				source = 'Go Open NC'
			
			// combine any Rethink Education courses
			} else if (source.search(/rethink education/i) > -1) {
				source = "Rethink Education"
			}

			// set source value on o based on above calculation (might not be the same as the content_source value in the resource)
			o.source = source

			if (empty(rbs[source])) rbs[source] = []
			rbs[source].push(o)

			return true
		},

		finalize_rbs(rbs) {
			let rsf = object_copy(this.resources_source_filters)
			let sources = []
			for (let source in rbs) {
				sources.push(source)
				// if this is the first time we've encountered this source...
				if (rsf[source] === undefined) {
					// if (source == 'Go Open NC') rsf[source] = false
					// else if (source == 'Other') rsf[source] = false

					// default: show resources from this source
					rsf[source] = true
				}
			}
			this.resources_source_filters = rsf

			// sort sources...
			sources.sort((a,b)=>{
				// put goopen and other at the bottom
				if (a == 'Go Open NC') {
					if (b == 'Other') return -1
					else return 1
				} else if (b == 'Go Open NC') {
					if (a == 'Other') return 1
					else return -1
				} else if (a == 'Other') return 1
				else if (b == 'Other') return -1

				else return U.natural_sort(a,b)
			})

			let rbs_sorted = {}
			for (let source of sources) rbs_sorted[source] = rbs[source]

			this.resources_by_source = rbs_sorted
		},

		toggle_select_all_sources(val) {
			// if val isn't boolean...
			if (typeof(val) != 'boolean') {
				// if all are off, toggle all on; otherwise toggle all off
				if (this.toggle_all_sources_icon == 'far fa-square') {
					val = true
				} else {
					val = false
				}
			}
			let rsf = object_copy(this.resources_source_filters)
			for (let source in rsf) rsf[source] = val
			this.resources_source_filters = rsf

			this.generate_searchable_items()
		},

		show_more_results(type) {
			this.items_showing_count[type] += this.items_per_page
		},

		cull_duplicate_searchable_items(arr) {
			// sort by type, title, then creation date desc -- so that newer items are first in the arr
			arr.sort((a,b)=>{
				if (a.category != b.category) return (a.category < b.category) ? -1 : 1
				if (a.type == 'resource') {
					if (a.value.type != b.value.type) return (a.value.type < b.value.type) ? -1 : 1
				}
				if (a.text != b.text) return (a.text < b.text) ? -1 : 1
				if (a.created_at != b.created_at) return (a.created_at > b.created_at) ? -1 : 1
				return 0
			})

			let arr2 = []
			let prev_asset = ''
			this.searchable_category_count = {'1lesson':0, '2sparkl':0, '3resource':0}
			for (let asset of arr) {
				// get a string representing the crucial data for this asset
				let type = (asset.type == 'resource') ? asset.value.type : 'lesson'
				let s = `${asset.category}-XX-${type}-XX-${asset.text}`

				// if this asset has exactly the same data as prev_asset, this is an older duplicate, so cull
				if (s == prev_asset) {
					continue
				}

				arr2.push(asset)

				// re-compute searchable_category_count
				this.searchable_category_count[asset.category] += 1

				prev_asset = s
			}
			return arr2
		},

		adjust_item_type_showing_for_collection() {
			this.$nextTick(x=>{
				// first, if item_type_showing doesn't match one of the available citem_types, fix this
				// (and unfortunately, we don't use the same vocabulary for citem_types and item_type_showing)
				let aa = []
				if (this.citem_types.includes('lessons')) aa.push('1lesson')
				if (this.citem_types.includes('activities')) aa.push('2sparkl')
				if (this.citem_types.includes('resources')) aa.push('3resource')
				if (!aa.includes(this.item_type_showing)) {
					this.item_type_showing = aa[0]
				}

				// if we just loaded a collection's items, item_type_showing might be set to an item type that this collection doesn't have any of, which causes a problem.
				if (empty(this.searchable_category_count[this.item_type_showing]) || this.searchable_category_count[this.item_type_showing] == 0) {
					for (let item_type in this.searchable_category_count) {
						if (this.searchable_category_count[item_type] > 0 && aa.includes(item_type)) {
							// console.warn('found new item_type: ' + item_type)
							this.item_type_showing = item_type
							return
						}
					}
				}
				// if we get to here, the collection may not have any items at all; don't change item_type_showing
			})
		},

		result_class(sr, hover) {
			let s = ''
			if (sr.already_added) s += ' k-full-resource-search-result-already-added'
			if (sr == this.last_previewed_item) s += ' indigo lighten-5'
			return s
		},

		created_date(sr) {
			let d 
			if (sr.category === "1lesson") {
				d = new Date(sr.value.created_at*1000)
			} else {
				d = date.parse(sr.value.created_at, 'YYYY-MM-DD HH:mm:ss')
			}
			return date.format(d, 'MMM D, YYYY')	// Jan 3, 2020 3:04 PM
		},

		item_checked(sr) {
			// if max_items is 1, only allow one item to be checked; so uncheck any item except sr
			if (this.max_items == 1) {
				for (let i = 0; i < this.searchable_items.length; ++i) {
					if (this.searchable_items[i] != sr) {
						this.searchable_items[i].selected = false
					}
				}
			}
		},

		async add_selected_items(flag) {
			if (!this.at_least_one_item_selected) return

			// add items that are selected and aren't already in the collection we're adding to
			let arr = this.searchable_items.filter(x=>x.selected && !x.already_added)

			// if we're adding items to a lesson, we always add shortcuts
			if (this.adding_to_lesson) {
				this.add_selected_items_finish(arr)
				return
			}

			let noun = (arr.length == 1) ? 'item' : `items`
			let origin_collection_title = this.selected_my ? 'your Default Collection' : `the selected collection (“${this.selected_collection.title}”)`
			let origin_collection_abbrev = this.selected_my ? 'your Default Collection' : 'the selected collection'
			let destination_noun = `the current collection (“${this.home_collection.title}”)`
			if (this.selected_home_collection) {
				// TODO: are we really supporting moving from one unit to another?
				origin_collection_title = `another unit in “${this.home_collection.title}”`
				origin_collection_abbrev = 'the other unit'
				destination_noun = 'the current unit'
			}

			// if flag says we're moving, warn the user what this means
			if (flag == 'move') {
				try {
					await this.$confirm({
						title: 'Confirm Move',
						text: `This action will move the selected item(s) from ${origin_collection_title} into ${destination_noun}, meaning that it will no longer be shown in the selected collection. Are you sure you want to do this?`,
						acceptText: 'Confirm Move',
						acceptIconAfter: 'fas fa-circle-arrow-right',
						dialogMaxWidth: 640,
					})

					// user accepted, so move the items
					this.move_items_before_adding(arr)

				} catch(e) { return }
				return
			}

			// else give the user the option to copy or add a shortcut
			try {
				let result = await this.$confirm({
					title: 'Copy or Make a “Shortcut”?',
					text: `Would you like to:<ul><li class="mt-1"><b>COPY</b> the selected ${noun} from ${origin_collection_title} to ${destination_noun}, or</li><li class="mt-1 mb-3">Make a <b>“SHORTCUT”</b> of the the selected ${noun} from ${origin_collection_abbrev} in ${destination_noun}?</li></ul>Note: if you make a shortcut, any changes to the original item(s) will automatically flow through to all shortcuts, and you can always make a copy of the original item for your use later. So the most common initial choice here is to make a <b>shortcut</b>.`,
					extraBtnText: '  Copy',
					extraBtnIconAfter: 'fas fa-copy',
					acceptText: 'Make Shortcut',
					acceptIconAfter: 'fas fa-location-arrow',
					cancelIcon: 'fas fa-times',
					dialogMaxWidth: 640,
				})

				// if they click the 'extra' btn, we will get result === 'extra', which means COPY
				if (result === 'extra') {
					this.copy_items_before_adding(arr)

				// else add SHORTCUTS, so just proceed to adding the collection_asset_mappings
				} else {
					this.add_selected_items_finish(arr)
				}

			} catch(e) { return }
		},

		move_items_before_adding(arr) {
			// We allow moving from your default collection AND from any collection user is the owner of, so we just have to first remove the items in whichever of those is the origin here
			// (note that we'll take care of agency_sanctioned flag in add_selected_items_finish)
			let payload = {
				user_id: this.user_info.user_id,
				assets: [],
			}

			for (let sr of arr) {
				let lp_id = ''
				let user_id = 0
				let unit_id = 0
				// If we are moving from a collection other than the default collection, we need to pass the collection ID in to the service
				if (!this.selected_my) {
					lp_id = this.collection_being_shown.lp_id

					// sr.lp_unit_id should be set to either the selected unit, if a unit is selected; or the first unit in which the item appears, if "all units" is selected
					// so remove the mapping for this unit
					unit_id = sr.lp_unit_id

					// if this is a my collection, send user_id -1, which tells the service to ignore the user_id field when removing the ca_mapping record
					// this is because 
					if (this.collection_being_shown.collection_type == 'my') {
						user_id = -1
					}
					// otherwise we will use user_id 0, which is appropriate for default collections
					// note that we will not be moving items from shadow units here (at least at this time; if we want to support that later we'll have to revisit this logic)

				// for items selected from your sandbox...
				} else {
					// we only remove ca mappings to your default collection
					let cam = this.$store.state.my_ca_mappings.find(x=>x.asset_id==sr.item_id)
					if (!cam) console.warn('COUND’T GET MY_CA_MAPPINGS RECORD')
					if (cam?.collection_id == `default_collection_${this.user_info.user_id}`) {
						lp_id = 0	// this will trigger the service to remove the sandbox mapping
					} else {
						// if we're here, this is an asset that appears in your sandbox, but doesn't have an explicit mapping to your default collection,
						// meaning that it's either in the "shadow unit" of an agency-sanctioned collection, or in a my collection
						// for these assets we'll add an alias to the place you're moving to, but we won't remove the asset from wherever it actually lives (because we can't be sure that's what you want to do)
						// if you really do want to remove the asset from wherever it lives:
						//   - for an asset in a my collection, you can explicitly delete it from the my collection
						//   - for a shadow unit asset, you could explicitly delete it from the shadow unit (although in this case it might still appear "overlaid" on the asset in the agency-sanctioned collection)
						continue
					}
				}

				// for each item, add [item_id, lp_id, user_id] (where lp_id might be empty, and user_id might be 0); the service will use these to decide what to remove
				/** Modified to send explicit key: value pairs to service - JR 9/25 */
				let ids = {
					asset_id: sr.item_id,
					user_id,
					lp_id,
					unit_id,
					asset_type: sr.type == 'lesson' ? 'lesson' : 'resource'
				}

				payload.assets.push(ids)
			}

			U.loading_start()
			U.ajax('remove_assets_from_collection', payload, result => {
				U.loading_stop()
				// note that we don't update the client until the service actually succeeds in removing the assets' mappings
				for (let sr of arr) {
					// If we are moving from the default collection...
					if (this.selected_my) {
						// remove the items from the user's default collection -- lessons are in unit 0, activities in unit 1, and other resources in unit 2
						if (sr.type == 'lesson') {
							let i = this.my_default_collection.units[0].lessons.findIndex(x => x.lesson_id == sr.item_id)
							if (i > -1) this.$store.commit('set', [this.my_default_collection.units[0].lessons, 'SPLICE', i])
						} else if (sr.type == 'activity') {
							let i = this.my_default_collection.units[1].resources.findIndex(x => x.resource_id == sr.item_id)
							if (i > -1) this.$store.commit('set', [this.my_default_collection.units[1].resources, 'SPLICE', i])
						} else {
							let i = this.my_default_collection.units[2].resources.findIndex(x => x.resource_id == sr.item_id)
							if (i > -1) this.$store.commit('set', [this.my_default_collection.units[2].resources, 'SPLICE', i])
						}
					} else {
						// Otherwise, we are moving from a collection owned/editable by by the current user, so figure out which unit the item was coming from and remove it
						const unit = this.collection_being_shown.units.find(x => x.lp_unit_id == sr.lp_unit_id)
						if (unit) {
							unit.remove_item_from_client(sr.item_id)
						}
					}
				}
				// If we didn't move from default collection...
				if (!this.selected_my) {
					// ...save the origin LP in the database, removing the moved lessons and resources from the lp unit resource_tree 
					// note: this could fail in the edge case that the LP is currently checked out. things should "degrade gracefully" though, since the resources won't be loaded because the mappings are gone
					this.$store.dispatch('save_learning_progression', {no_lock: true, lp: this.collection_being_shown}).then(() => {
						this.add_selected_items_finish(arr)
					}).catch(()=>{
						this.add_selected_items_finish(arr)
					})

				// Otherwise, we did move from the default collection...
				} else {
					this.add_selected_items_finish(arr)
				}
			})
		},

		async copy_items_before_adding(arr) {
			// if we're copying a single item, ask for a new title
			let new_title
			if (arr.length == 1) {
				new_title = arr[0].text
				try {
					new_title = await this.$prompt({
						title: 'Title for Copied Item',
						text: `If you would like to edit the title of the copied item, you can do so here. (You can also edit the copy after it’s created.)`,
						initialValue: new_title,
						acceptText: 'Make Copy',
						acceptIconAfter: 'fas fa-circle-arrow-right',
						cancelText: 'Cancel Copy',
						dialogMaxWidth: 640,
					})

					// trim; if empty return
					new_title = $.trim(new_title)
					if (empty(new_title)) return

				} catch(e) { console.warn(e); return; }	// if user clicks cancel here, cancel the move
			}

			// make copies of all assets (even resources), then add the copies (note that we'll take care of agency_sanctioned flag in add_selected_items_finish)
			let payload = {
				user_id: this.user_info.user_id, 
				resource_ids: [], 
				lesson_ids: [],
				// when we copy an activity this way -- when adding to a collection -- we *always* copy the activity's exercises, even if it's an agency-sanctioned activity
				copy_exercises: 'yes',
			}

			// add new_title if we have one and it isn't different than the item's title
			if (!empty(new_title) && new_title != arr[0].text) {
				payload.new_title = new_title
			}

			for (let sr of arr) {
				if (sr.type == 'lesson') payload.lesson_ids.push(sr.item_id)
				else payload.resource_ids.push(sr.item_id)
			}
			U.loading_start()
			U.ajax('copy_assets_for_adding_to_collection', payload, result=>{
				U.loading_stop()

				if (result.status != 'ok') {
					this.$alert(result.status)
					return
				}

				// replace the asset id's in arr with the newly-created assets
				for (let o of result.copies) {
					// note that arr contains references to the objects in sr 
					let sr = this.searchable_items.find(x=>x.item_id == o.original_item_id)	// don't worry about searching on type, because lesson item_ids are integers and resource/activity item_ids are guids
					if (sr) {	// this should always evaluate to true
						// switch to the copied item_id and copied lesson/resource record
						sr.item_id = o.copied_item_id
						if (sr.type == 'lesson') sr.value = new Lesson(o.lesson_data)
						else sr.value = new Resource(o.resource_data)
					}
				}

				// now continue adding; we will add the copies
				this.add_selected_items_finish(arr)
			})

			// TODO: account for indicating, in search results, items where we have already added copies of the item into the current collection
		},

		add_selected_items_finish(arr) {
			// add_items_from_search in the parent should take care of saving the mappings and json for the collection we're adding to
			this.$emit('add_items_from_search', arr)

			// mark these items as already_added, using set for quick lookup
			const arr_item_ids = new Set(arr.map((item) => item.item_id))
			for (let i = 0; i < this.searchable_items.length; ++i) {
				if (arr_item_ids.has(this.searchable_items[i].item_id)) {
					let sr = Object.assign({}, this.searchable_items[i])
					sr.already_added = true
					this.searchable_items.splice(i, 1, sr)
				}
			}
		},

		show_sparkl(sparkl_item_to_open, embed_mode) {
			// originally borrowed from ResourceCollectionItem.vue
			// This structure holds the info used in SparklEmbed, which we extract here from the resource object
			let activity_record = {
				tool_activity_id: sparkl_item_to_open.url,
				lti_resource_link_id: sparkl_item_to_open.resource_id,
				activity_title: sparkl_item_to_open.description,
				creator_user_id: sparkl_item_to_open.creator,
			}

			// override sparkl_origin if the collection tells us to do so (used for AP Sparkl activities, e.g.)
			let sparkl_origin_override = null
			if (this.home_collection && !empty(this.home_collection.sparkl_origin_override)) {
				sparkl_origin_override = this.home_collection.sparkl_origin_override
			}

			this.open_sparkl_activity_embed_object = {
				resource: sparkl_item_to_open,
				activity_record: activity_record,
				embed_mode: embed_mode,	// 'view' or 'edit'
				in_unit_editor: true,	// TODO: this might be false
				in_my_default_collection: false,	// TODO: this might be true
				// viewing_original_of_in_my_collections: false,
				controller_component: this,
				sparkl_origin_override: sparkl_origin_override,
			}
			vapp.$refs.sparkl_embed.show_activity(this.open_sparkl_activity_embed_object)

			// hide active dialogs/overlays while the activity shows (e.g. the unit editor might be showing)
			$('.v-dialog__content--active, .v-overlay--active').hide()
		},

		// this is called by the SparklEmbed component when the user clicks the "CLOSE" btn in Cureum (controller_component.close_sparkl())
		close_sparkl() {
			// if the activity is open for editing, we need to ask Sparkl if anything needs to be saved
			if (this.open_sparkl_activity_embed_object.embed_mode == 'edit') {
				U.loading_start()	// we'll close the spinner in close_sparkl_finish
				// send the host_activity_saved message TO sparkl, so that Sparkl saves anything that might have been edited there
				vapp.$refs.sparkl_embed.execute('host_activity_saved', {})

				this.sparkl_closed_from_embed = true
				// ... then once sparkl is done saving, sparkl_activity_saved (below) will be called, and since sparkl_closed_from_embed is true, sparkl_activity_saved will call close_sparkl_finish

			} else {
				// not open for editing, so close immediately
				this.close_sparkl_finish()
			}
		},

		close_sparkl_finish() {
			U.loading_stop()
			// reset sparkl_closed_from_embed
			this.sparkl_closed_from_embed = false

			// clear open_sparkl_activity_embed_object
			this.open_sparkl_activity_embed_object = null

			// call sparkl_embed.hide_activity
			vapp.$refs.sparkl_embed.hide_activity()

			// re-show active dialogs/overlays
			$('.v-dialog__content--active, .v-overlay--active').show()

			if (this.new_activity) {
				// clear new_activity and new_activity_saved if set
				this.new_activity = null
				this.new_activity_saved = false
				this.$emit('dialog_cancel')
			}
		},

		// TODO: fill this in...
		copy_to_my_content() {
			this.$alert('You are currently previewing this activity.')
		},

		///////////////////////////////////////// Import
		async import_shared_item(item_type) {			
			/////////////////////////////////////////////////////////////
			// get item id to import from the user
			let params = {acceptText:'Import'}
			let noun
			if (item_type == 'lesson') {
				noun = 'Lesson'
				params.title = 'Import Shared Lesson'
				params.text = 'Enter the Import ID for the lesson you wish to import:<div class="mt-2" style="font-size:14px;font-style:italic">This ID should start with an “L”.</div>'
			} else if (item_type == 'activity') {
				noun = 'Activity'
				params.title = 'Import Shared Activity'
				params.text = 'Enter the Import ID for the activity you wish to import:<div class="mt-2" style="font-size:14px;font-style:italic">This ID should start with an “A”.</div>'
			} else {
				noun = 'Resource'
				params.title = 'Import Shared Resource'
				params.text = 'Enter the Import ID for the resource you wish to import:<div class="mt-2" style="font-size:14px;font-style:italic">This ID should start with “R-”.</div>'
			}

			let entered_item_id
			try {
				entered_item_id = await this.$prompt(params)
			} catch(e) { console.warn('catch', e); return; }	// user clicked cancel

			// If the entered_item_id starts with this pattern, the initial value should be a import_from_cureum_prefix,
			// and this means we're doing a COPY from the `import_from_cureum_prefix` cureum instance
			let import_from_cureum_prefix = ''
			let match = entered_item_id.match(/^([A-Z][A-Z]+)-(.*)$/)
			if (match) {
				import_from_cureum_prefix = match[1]
				entered_item_id = match[2]
			}

			// get item_id from user input and check for formatting
			match = entered_item_id.match(/^([ALR])(-?)([\w-]+)$/)
			if (!match) {
				this.$alert('The ID you entered is not valid.').then(()=>this.import_shared_item())
				return
			}
			let item_id = match[3]

			/////////////////////////////////////////////////////////////
			// unless we're importing from another cureum, call a service to find the specified asset
			let original_asset_data
			if (!import_from_cureum_prefix) {
				let payload = { user_id: this.user_info.user_id, }
				if (item_type == 'lesson') payload.lesson_id = item_id
				else payload.resource_id = item_id

				U.loading_start()
				let ajax_result = await U.ajax_promise('get_asset_data_for_importing_to_collection', payload)
				U.loading_stop()
				if (ajax_result.status != 'ok') {
					// the service could fail because the user enters an invalid item ID
					if (ajax_result.status == 'bad_item_id') ajax_result.status = `The Item ID you entered (${entered_item_id}) was invalid.`
					this.$alert(ajax_result.status)
					return
				}

				original_asset_data = ajax_result.resource_data || ajax_result.lesson_data
				console.warn('original_asset_data', original_asset_data)
			}

			/////////////////////////////////////////////////////////////
			// now find out if the user wants to copy or add a shortcut; sync confirm text with add_selected_items
			// if we're importing from another cureum, actiion is always 'copy'
			let action
			if (import_from_cureum_prefix) {
				action = 'copy'
				
			} else {
				try {
					let result = await this.$confirm({
						title: 'Copy or Make a “Shortcut”?',
						text: `Would you like to:<ul><li class="mt-1">Make a <b>COPY</b> of the specified ${noun}, or</li><li class="mt-1 mb-3">Make a <b>“SHORTCUT”</b> of the the specified ${noun}?</li></ul>Note: if you make a shortcut, any changes to the original item will automatically flow through to all shortcuts, and you can always make a copy of the original item for your use later. So the most common initial choice here is to make a <b>shortcut</b>.`,
						extraBtnText: '  Copy',
						extraBtnIconAfter: 'fas fa-copy',
						acceptText: 'Make Shortcut',
						acceptIconAfter: 'fas fa-location-arrow',
						cancelIcon: 'fas fa-times',
						dialogMaxWidth: 640,
					})

					// if they click the 'extra' btn, we will get result === 'extra', which means COPY; else result will be true, which means SHORTCUT
					if (result === 'extra') {
						action = 'copy'
					} else {
						action = 'shortcut'
					}
				} catch(e) { console.warn('catch', e); return; }	// user clicked cancel
			}

			let asset_data_to_import

			/////////////////////////////////////////////////////////////
			// for a shortcut...
			if (action == 'shortcut') {
				// you can't (at least currently) add shortcuts of the same item multiple times in the same unit, so reject if this is the case
				// note that if adding_to_lesson is true, we're importing to a *lesson*, and there you can do this (?)
				if (!this.adding_to_lesson && this.home_unit) {
					if (item_type == 'resource') {
						if (this.home_unit.resources.find(x=>x.resource_id==item_id)) {
							this.$alert('The specified resource already exists in this unit. You cannot include two shortcuts to the same resource in the same unit.')
							return
						}
					} else if (item_type == 'activity') {
						if (this.home_unit.resources.find(x=>x.url==item_id)) {
							this.$alert('The specified activity already exists in this unit. You cannot include two shortcuts to the same activity in the same unit.')
							return
						}
					} else {	// lesson
						if (this.home_unit.lessons.find(x=>x.lesson_id==item_id)) {
							this.$alert('The specified lesson already exists in this unit. You cannot include two shortcuts to the same lesson in the same unit.')
							return
						}
					}
				}

				asset_data_to_import = original_asset_data
				// this.import_shared_item_finish(item_type, result)

			/////////////////////////////////////////////////////////////
			// for a copy...
			} else {	// (action == 'copy') {
				/////////////////////////////////////////////////////////////
				// if we're not importing from external cureum,
				let new_title = ''
				if (!import_from_cureum_prefix) {
					// ask the user if they want to rename
					new_title = original_asset_data.lesson_title || original_asset_data.description
					try {
						new_title = await this.$prompt({
							title: 'Title for Copied Item',
							text: `If you would like to edit the title of the copied item, you can do so here. (You can also edit the copy after it’s created.)`,
							initialValue: new_title,
							acceptText: 'Make Copy',
							acceptIconAfter: 'fas fa-circle-arrow-right',
							cancelText: 'Cancel Copy',
							dialogMaxWidth: 640,
						})
					} catch(e) { console.warn(e); return; }	// if user clicks cancel here, cancel the move
					// trim new_title; if empty return
					new_title = $.trim(new_title)
					if (empty(new_title)) return
				}

				/////////////////////////////////////////////////////////////
				// use copy_assets_for_adding_to_collection to copy the specified item
				let payload = {
					user_id: this.user_info.user_id, 
					resource_ids: [], 
					lesson_ids: [],
					agency_sanctioned: (this.new_items_are_agency_sanctioned ? 'yes' : 'no'),
				}

				// send import_from_cureum_prefix if we got it
				if (import_from_cureum_prefix) {
					payload.import_from_cureum_prefix = import_from_cureum_prefix

				// else send in the new_title
				} else {
					payload.new_title = new_title
				}

				// if we're using a sparkl_origin_override for this collection, send it in
				if (this.home_collection && !empty(this.home_collection.sparkl_origin_override)) {
					payload.sparkl_origin_override = this.home_collection.sparkl_origin_override
				}

				if (item_type == 'lesson') payload.lesson_ids.push(item_id)
				else payload.resource_ids.push(item_id)

				U.loading_start()
				let ajax_result = await U.ajax_promise('copy_assets_for_adding_to_collection', payload)
				U.loading_stop()

				if (ajax_result.status != 'ok') {
					this.$alert('An error occurred when attempting to copy the item: ' + ajax_result.status)
					return
				}

				asset_data_to_import = ajax_result.copies[0].resource_data || ajax_result.copies[0].lesson_data
				// this.import_shared_item_finish(item_type, result.copies[0])
			}

			/////////////////////////////////////////////////////////////
			// simulate a search result with the asset_data_to_import
			let sr, o
			if (item_type == 'lesson') {
				o = new Lesson(asset_data_to_import)
				sr = {
					type: 'lesson',
					item_id: o.lesson_id,
					text: o.lesson_title,
				}
			} else {
				o = new Resource(asset_data_to_import)
				sr = {
					type: 'resource',
					item_id: o.resource_id,
					text: o.description,
				}
			}
			sr.value = o
			sr.already_added = true
			sr.selected = true

			// add to imported_items
			this.imported_items.push(sr)

			// add the item the same way we would if we'd found this item using a search
			this.add_selected_items_finish([sr])
		},

		///////////////////////////////////////// Create
		create_new_resource() {
			let o = {
				resource_id: 'new',
				agency_sanctioned: this.new_items_are_agency_sanctioned,
				publish_status: this.new_items_are_agency_sanctioned ? 'published' : null,
				description: '',
				type: this.$store.state.lst.resource_editor_resource_type,
				teacher_facing: this.$store.state.lst.resource_editor_teacher_facing,
			}

			// if we're in the context of a collection with a subject and/or grade, set mappings (e.g. 'grade-4', or 'subject-Math')
			// BUT ONLY if we're using PD resources for this cureum instance
			if (this.home_collection && this.site_config.show_pd == 'yes') {
				let mappings = []
				if (this.home_collection.subject) mappings.push('subject-' + this.home_collection.subject.toLowerCase())

				if (this.home_collection.grade_low == 'K' && this.home_collection.grade_high == '5') mappings.push('grade-elem')
				else if (this.home_collection.grade_low == '6' && this.home_collection.grade_high == '8') mappings.push('grade-mid')
				else if (this.home_collection.grade_low == '9' && this.home_collection.grade_high == '12') mappings.push('grade-high')
				else if (this.home_collection.grade_low == 'K' && this.home_collection.grade_high == '12') mappings.push('grade-all')
				else if (this.home_collection.grade_low) mappings.push(('grade-' + this.home_collection.grade_low).toLowerCase())

				if (mappings.length > 0) o.mappings = mappings
			}

			let r = new Resource(o)
			r.is_new_resource = true
			this.new_resource_placeholder = r
		},

		create_resource_saved(resource_data) {
			// add created resource like we do with search
			let r = new Resource(resource_data)
			let sr = {
				type: 'resource',
				item_id: r.resource_id,
				value: r,
				text: r.description,
				already_added: true,
				selected: true,
			}
			// the handler of add_items_from_search will add the resource to whatever collection we're saving
			this.$emit('add_items_from_search', [sr])
			this.create_resource_cancel()
			this.$emit('dialog_cancel')
		},

		create_resource_cancel() {
			this.new_resource_placeholder = null
		},

		create_lesson_start() {
			// create new_lesson
			this.new_lesson = new Lesson({
				lesson_title: '',
				lp_variant: this.use_llm_for_new_lessons ? 'B' : 'A',
				creator_user_id: this.user_info.user_id,
				agency_sanctioned: this.new_items_are_agency_sanctioned,
				publish_status: this.new_items_are_agency_sanctioned ? 'published' : null,
				course_code: this.home_collection ? this.home_collection.course_code : '',
				lp_unit_id: this.home_unit ? this.home_unit.lp_unit_id : 0,
			})

			// set new_lesson_class; by default it's 'teacher'
			this.new_lesson_class = 'teacher'
			// TODO: determine if this should be a template lesson
			// if (this.item_to_show.is_lesson_template) this.new_lesson_class = 'template'

			// if we're using the LPC and this is the first time the user has created a lesson in this session, show the LPC info dialog
			if (this.use_llm_for_new_lessons && !vapp.lpc_info_shown) {
				// vapp.show_llm_lesson_plan_description()
			}
		},

		create_lesson_cancel() {
			this.new_lesson = null
		},

		create_lesson_saved(args) {
			// the lesson editor will have saved the resource to the db
			let l = new Lesson(args.updated_lesson)
			let sr = {
				type: 'lesson',
				item_id: l.lesson_id,
				value: l,
				text: l.lesson_title,
				already_added: true,
				selected: true,
			}

			// apply *_showing values from edited_lesson
			if (args.edited_lesson) {	// this should always be true
				l.resources_showing = args.edited_lesson.resources_showing
				l.standards_showing = args.edited_lesson.standards_showing
				l.student_description_showing = args.edited_lesson.student_description_showing
				for (let i = 0; i < args.edited_lesson.lesson_plan.length; ++i) {
					l.lesson_plan[i].lc_showing = args.edited_lesson.lesson_plan[i].lc_showing
					l.lesson_plan[i].lc_open_for_editing = args.edited_lesson.lesson_plan[i].lc_open_for_editing
				}
			}

			// if we just saved the newly-created lesson for the first time...
			if (this.new_lesson.lesson_id == 0) {
				// add the lesson like we do with search -- the handler of add_items_from_search will add the lesson to whatever collection we're saving
				this.$emit('add_items_from_search', [sr])

				// set new_lesson to l, and allow the user to continue to edit it (unless the flag says to close)
				if (args.flag != 'and_close') {
					this.new_lesson = null
					this.$nextTick(x=>this.new_lesson = l)
				}

			} else {
				// else the user saved once and continued editing, so use edit_item_saved to save it
				this.edit_item_saved({type:'lesson', updated_lesson: l})
			}

			// if the flag is 'and_close', close the editor
			if (args.flag == 'and_close') {
				this.create_lesson_cancel()
				this.$emit('dialog_cancel')
			}
		},

		create_activity_start() {
			this.$prompt({
				title: `Create New ${this.site_config.sparkl_app_name} Student Activity`,
				text: 'Enter new activity title:',
				initialValue: '',
				disableForEmptyValue: true,
				acceptText: 'Create Activity',
				acceptIconAfter: 'fas fa-circle-arrow-right',
			}).then(title => {
				title = $.trim(title)
				if (empty(title)) return

				// create a stub of the new activity to be created
				this.new_activity = new Resource({
					resource_id: 'new',	// triggers a new guid
					agency_sanctioned: this.new_items_are_agency_sanctioned,
					publish_status: this.new_items_are_agency_sanctioned ? 'published' : null,
					type: 'sparkl',
					url: '0',	// sparkl activity_id; this triggers sparkl to create a new sparkl activity
					description: title,
					creator: this.user_info.user_id,
				})
				this.new_activity_saved = false
				
				// open sparkl_embed to show the activity
				this.show_sparkl(this.new_activity, 'edit')
				// as user saves/closes, sparkl_activity_saved will be called

			}).catch(n => { console.error(n) })
		},

		sparkl_activity_saved(activity_data_from_sparkl) {
			// this is called when Sparkl issues a 'sparkl_activity_saved' message
			// activity_data_from_sparkl should include sparkl_activity_id, stars_available, activity_instructions, activity_title, activity_editors
			// note that for a newly-created activity, activity_id and tool_activity_id will both initially be 0

			// NOTE: removing code from ResourceCollectionItem that is executed when sparkl_activity_owned_by_user is false... we might need to bring this back; it is used either when "finishing the process of copying the activity to my content", or when editing a resource that is actually owned by the teacher, mostly in the unit editor context

			// NOTE: Code below needs to be kept in synch with ResourceCollectionItem (it's not identical, but some things are the same)
			let changed = false
			let resource_copy = this.open_sparkl_activity_embed_object.resource.copy_for_save()

			// if sparkl_activity_id is changed, set it
			if (activity_data_from_sparkl.sparkl_activity_id && activity_data_from_sparkl.sparkl_activity_id != resource_copy.url) {
				resource_copy.url = activity_data_from_sparkl.sparkl_activity_id
				changed = true
			}
			
			// ditto the activity title
			if (activity_data_from_sparkl.activity_title && activity_data_from_sparkl.activity_title != resource_copy.description) {
				resource_copy.description = activity_data_from_sparkl.activity_title
				changed = true
			}

			// ditto case_alignments
			if (activity_data_from_sparkl.case_alignments && !this.open_sparkl_activity_embed_object.resource.standards_match(activity_data_from_sparkl.case_alignments)) {
				resource_copy.standards = activity_data_from_sparkl.case_alignments
				changed = true
			}

			// if we receive a long_description, set resource.long_description to it
			if (activity_data_from_sparkl.long_description) {
				if (resource_copy.long_description != activity_data_from_sparkl.long_description) {
					resource_copy.long_description = activity_data_from_sparkl.long_description
					changed = true
				}

			// else build activity description from the rest of the activity_data_from_sparkl; if changed, set it in resource.long_description
			// (we're not currently using this description, but we might in the future)
			} else if (activity_data_from_sparkl.stars_available) {
				let d = `Student activity with ${activity_data_from_sparkl.stars_available} star${activity_data_from_sparkl.stars_available == 1 ? '' : 's'} available to be earned`
				
				if (resource_copy.long_description != d) {
					resource_copy.long_description = d
					changed = true
				}
			}

			// if open_to_exercise_bank is 'bravo', that means this is sparkl_bank resource; otherwise it's a "normal" sparkl activity
			let resource_type = (activity_data_from_sparkl.open_to_exercise_bank == 'bravo') ? 'sparkl_bank' : 'sparkl'
			if (resource_type != resource_copy.type) {
				resource_copy.type = resource_type
				changed = true
			}

			// if we changed anything, save the activity resource to the db (if it was a new activity, the sparkl_activity_id/url will have changed from 0 to the newly-created sparkl activity_id, so changed will have been set to true above)
			if (changed) {
				U.loading_start()
				this.$store.dispatch('save_resource', { resource: new Resource(resource_copy) }).then(saved_resource_data => {
					U.loading_stop()

					let r = new Resource(saved_resource_data)
					let sr = {
						type: 'resource',
						item_id: r.resource_id,
						value: r,
						text: r.description,
						already_added: true,
						selected: true,
					}

					// if we're showing a newly-created activity...
					if (this.new_activity) {
						// follow pattern from create_lesson_saved: if we just saved a newly-created activity for the first time...
						if (!this.new_activity_saved) {
							// add the activity like we do with search -- the handler of add_items_from_search will add the activity to whatever collection we're saving
							this.$emit('add_items_from_search', [sr])
							this.new_activity_saved = true

						} else {
							// else the user saved once and continued editing, so use edit_item_saved to save it
							this.edit_item_saved({type:'resource', updated_resource: r})
						}

						// set this.new_activity to the new version of the resource
						this.new_activity = r
					
					// else user is previewing an activity they are an editor for, and has made a change (we can't stop them from doing this)
					} else {
						// emit edit_item_saved to update the activity in whatever collection we're editing
						this.edit_item_saved({type:'resource', updated_resource: r})
					}

					// set open_sparkl_activity_embed_object.activity_record to the new activity resource data
					this.open_sparkl_activity_embed_object.activity_record = {
						tool_activity_id: r.url,
						lti_resource_link_id: r.resource_id,
						activity_title: r.description,
						creator_user_id: r.creator,
					}

					// once activity is saved, if sparkl_closed_from_embed is true, finish closing sparkl
					if (this.sparkl_closed_from_embed) this.$nextTick(()=>this.close_sparkl_finish())
				})
				// return here so we don't call close_sparkl_finish too quickly below 
				return
			}

			// if we didn't have to save, and sparkl_closed_from_embed is true, finish closing sparkl here
			if (this.sparkl_closed_from_embed) this.close_sparkl_finish()
		},

		edit_item_start() {
			// we used to issue a warning here, but now the warning isn't relevant anymore
		},

		edit_item_saved(args) {
			// args must include type ('resource' or 'lesson') and (updated_resource or updated_lesson)
			let asset

			if (this.handle_edit_item_saved) {
				// if we were launched from a context that is handling edit_item_saved itself, the updated_resource or updated_lesson MUST be an instantiated instance; just send it through (the handler will commit update_content_item)
				this.$emit('edit_item_saved', args)
				if (args.updated_resource) asset = new Resource(args.updated_resource)
				else asset = new Lesson(args.updated_lesson)

			} else {
				// otherwise instantiate the asset...
				if (args.updated_resource) asset = new Resource(args.updated_resource)
				else asset = new Lesson(args.updated_lesson)
				// and call update_content_item mutation to make sure the item's changes are reflected everywhere
				this.$store.commit('update_content_item', asset)
			}

			// we also have to update the asset in searchable_items, so that the change is reflected here in the search
			if (asset.lesson_id) {
				let si = this.searchable_items.find(x=>x.item_id == asset.lesson_id)
				if (si) {
					si.value = asset
					si.text = asset.lesson_title
					si.text_lc = si.text.toLowerCase()
				}
			} else {
				let si = this.searchable_items.find(x=>x.item_id == asset.resource_id)
				if (si) {
					si.value = asset
					si.text = asset.description
					si.text_lc = si.text.toLowerCase()
				}
			}
		},

		copy_to_shadow_unit_finish(copied_item) {
			console.warn('copy_to_shadow_unit_finish in ResourceSearch')
			// this is called via an emitter from ResourceCollectionItem when a sparkl or lesson is copied for the user's use.

			let msg, noun
			if (copied_item.lesson_id) {
				msg = 'A copy of the Lesson has been created for your use. You can modify your copy of the the Lesson now.'
				noun = 'Lesson'
			} else {
				msg = 'A copy of the Activity has been created for your use. You can use the Activity with your students, and/or modify the Activity if you wish, now.'
				noun = 'Activity'
			}

			// add to the user's sandbox
			// (if we're in the context of a unit, we could in theory add to the unit's shadow unit, but it's hard to know here if we *are* in the context of a unit, and the item will show up in the shadow unit of the collection where the item lives even if it's just added to the sandbox)
			msg += `<div class="mt-3">You can access the copied ${noun} from your Content Sandbox.`

			// make sure we have access to the default collection (we should)
			let dc = this.$store.getters.my_default_collection
			if (empty(dc?.units[1])) {
				this.$alert('Error: can’t save activity resource (323)')
				return
			}

			// add the copied sparkl resource to the user's sandbox, then call the save_default_collection_resources service (see CollectionUnit)
			if (copied_item.lesson_id) dc.units[0].lessons.push(copied_item)
			else dc.units[1].resources.push(copied_item)
			this.$store.dispatch('save_default_collection_resources').then(() => {
				console.warn('save_default_collection_resources done (ResourceSearch)')
			})

			if (this.site_config.copied_for_my_use_warning) {
				msg += `<div class="mt-3 pt-3 px-5" style="border-top:1px solid #ccc; font-size:14px; line-height:18px;">${this.site_config.copied_for_my_use_warning}</div>`
			}

			// show the message
			this.$alert({
				text: msg,
				dialogMaxWidth: 500,
			}).then(y => {
			})
		},

		///////////////////////////////////////
		done_clicked() {
			if (this.at_least_one_item_selected) {
				this.$confirm({
					title: 'Add Item(s) Before Closing?',
					text: `You have selected at least one item to add. Would you like to add this/these items before closing the search interface?`,
					cancelText: 'Add items, then close',
					acceptText: 'Close without adding',
					dialogMaxWidth: 600,
					focusBtn: true,		// focus on the accept btn when dialog is rendered
				}).then(y => {
					this.$emit('dialog_cancel')
				}).catch(n=>{
					// note that the "add" option is in the cancel position
					this.add_selected_items()
					this.$emit('dialog_cancel')
				}).finally(f=>{})
			} else {
				this.$emit('dialog_cancel')
			}
		},

		use_llm_clicked(confirmed) {
			// if we're here, the user has clicked to switch between the OG and LLC editor. warn them if they've already started editing
			if (!empty(this.$refs.lesson_editor.edited_lesson.lesson_title) && confirmed !== true) {
				this.$confirm({
					text: 'If you switch the lesson editor interface at this time, you will lose any work you’ve already done on this lesson in the current editor interface. Are you sure you want to switch?',
					acceptText: 'Yes, Switch',
				}).then(y => {
					this.use_llm_clicked(true)
					
				}).catch(n=>{
					// if they switch to cancel, revert use_llm_for_new_lessons and don't switch
					this.use_llm_for_new_lessons = !this.use_llm_for_new_lessons

				}).finally(f=>{})
				return
			}

			// copy through the title if entered
			this.new_lesson.lesson_title = this.$refs.lesson_editor.edited_lesson.lesson_title

			if (this.use_llm_for_new_lessons) {
				this.new_lesson.lp_variant = 'B'
				// this.show_llm_lesson_plan_description()
			} else {
				this.new_lesson.lp_variant = 'A'
			}
		},
		show_llm_lesson_plan_description() { vapp.show_llm_lesson_plan_description() },
		
		unpublish_item_start() {
			this.$inform({text: `Note that if you unpublish this item, you may need to refresh your browser window to see the change reflected in the ${this.site_config.app_name} user interface.`, timeout:5000})
		},
	}
}
</script>

<style lang="scss">
// in lti_chooser mode, the dialog should fill the whole window, except for the top 48px
.k-search-dialog-lti-chooser {
	top:48px;
	height:calc(100vh - 48px);

	.v-card {
		border-radius:0;
	}
	.k-search-card {
		// background-color:#e3e3e3;
	}
}

// when we're in "search mode", we need the dialog to be wider and have a min-height
.k-search-dialog-search {
	max-width:1180px;
	min-height:85vh;
}
.k-search-dialog-new {
	max-width:900px;
}

.k-search-card {
	font-size:16px;
	color:#000;
	background-color:#eee;

	.v-input--selection-controls__input {
		margin-right:4px;
	}
	.v-label {
		color:#000;
		padding-left:0;
	}

	.v-btn.k-toggle-btn-active-class {
		background-color:$v-indigo-darken-3!important;
	}

	input::placeholder {
		color:$v-indigo-lighten-1!important;
	}
	.v-input--is-focused {
		input::placeholder {
			color:$v-indigo-lighten-4!important;
		}
	}

	.v-text-field .fa-filter {
		font-size:20px;
		margin-left:-4px;
	}
}

.k-search-options-holder {
	white-space:nowrap; 
	background-color:#fff; 
	padding:8px 12px; 
	border-radius:6px;
	height:80px;

	.v-btn__content {
		max-width:200px;
		letter-spacing:0.25px;
	}
}

.k-search-options-holder-label {
	font-weight:800;
	font-size:14px;
	line-height:14px;
	margin-bottom:6px;
	padding-left:2px;
}

.k-full-resource-search-result-category {
	background-color:$v-indigo-lighten-4;
	padding:4px 8px;
	border-radius:3px;
	margin-top:20px;
}

.k-full-resource-search-result {
	display:flex;
	// margin:2px 0 6px 0;
	padding:4px 0 0px 4px;
	font-size:14px;
	border-radius:4px;
}

.k-full-resource-search-result-unit {
	color:#555;
	font-size:0.85em;
	margin-left:8px;
}

.k-full-resource-search-result-from-lesson {
	color:#555;
	font-size:0.85em;
	margin-left:8px;
}

.k-full-resource-search-result-already-added {
	opacity:0.7;
}

// use this class for the button that initializes a search; assumes by default that the v-btn is size small
.k-search-initialize-btn {
	background-color:#fff;
	position:relative;
	padding-right:42px!important;
	// border-width:2px;
	border-color:#444;
	color:#444!important;
	font-weight:normal!important;
	letter-spacing:0.25px;
	border-radius:4px!important;
	text-transform:none!important;
	.k-search-initialize-btn-icon-div {
		position:absolute;
		right:-42px;
		top:-6px;
		height:26px;
		width:30px;
		background-color:#444;
		border-radius:0 3px 3px 0;
		color:#fff;
		.fa-search {
			padding-top:5px;
		}
	}
}

.k-search-initialize-btn.v-size--default {
	padding-right:48px!important;
	height:40px!important;
	font-size:16px!important;
	// width:240px;
	.k-search-initialize-btn-icon-div {
		right:-48px;
		top:-10px;
		height:39px;
		.fa-search {
			font-size:18px!important;
			padding-top:10px;
		}
	}
}

.k-standards-search-results-wrapper {
	max-width:800px;
	margin:0 auto;
	font-size:16px;
	line-height:20px;

	.k-standards-search-result:nth-child(even) { background-color:#fff; }
	.k-standards-search-result:nth-child(odd) { background-color:#f8f8f8; }
}

.k-resource-search-in-filtered-items-true {
	position:relative;
}
.k-resource-search-in-filtered-items-true::before {
	content: "";
	position: absolute;
	top: 0; left: 0; right: 0; bottom: 0;
	background-color: rgba(255, 255, 0, 0.2);
	mix-blend-mode: multiply;
	z-index: 1;
	pointer-events: none; /* So it doesn't block clicks */
}

// .k-resource-search-in-filtered-items-false {
// 	opacity:0.8;
// }

.k-resource-search-results-no-results {
	text-align:center;
	border-radius:4px;
	background-color:$v-red-lighten-5;
	padding:8px;
	width:400px;
	margin-left:auto;
	margin-right:auto;
}

.k-search-options-search-in-descriptor {
	text-overflow: ellipsis; 
	overflow:hidden;
	max-width:200px;
}

.k-resources-by-source-filter {
	// position:absolute;
	// left:100%;
	// top:0;
	min-width:200px;
	// z-index:1;
	background-color:#fff;
	border-radius:6px;
	padding:8px;
	font-size:14px;
	label {
		white-space:nowrap;
		font-size:14px;
		margin-left:4px;
	}
}
</style>
